// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.sales-product-analytics-dashboard {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 0 16px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: visible;
  color: #17325c;
  font-family: "opensans", sans-serif;
  /* KPI row is first child of Spin container — force full width so cards can flex */
  /* Three KPIs: equal columns across full row. Compound selector beats OmnichannelAnalyticsTabsDashboard.scss,
     which reuses this block name and would otherwise override --three with repeat(4). */
  /* Must stay 5 tracks (matches hidden inventory KPI); TS also sets gridTemplateColumns for reliability */
  /**
   * Recharts positions every tick/label with absolute SVG coordinates and \`text-anchor\`,
   * assuming an LTR flow. Inheriting \`dir="rtl"\` from <html> flips that anchoring and
   * clips axis labels off the edge, so the SVG stays LTR and axis/label sides are
   * mirrored through props instead (see \`rtlChartProps\`).
   * Scoped to the surface only — \`.recharts-tooltip-wrapper\` is a sibling div that must
   * keep the page direction so its Arabic text and punctuation read correctly.
   */
  /* Recharts can paint slightly outside the box — avoid clipping in flex layouts */
  /* Global \`.dashboard-data-table-panel\` uses overflow:hidden, which can clip the inner scroll+table in grid layouts. */
}
.sales-product-analytics-dashboard__tabs {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  margin-bottom: 18px;
  border-radius: 18px;
  background: hsla(220, 10%, 46%, 0.08);
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__tab {
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: hsl(220, 10%, 46%);
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.15;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.sales-product-analytics-dashboard__tab:hover {
  background: rgba(255, 255, 255, 0.72);
  color: #17325c;
}
.sales-product-analytics-dashboard__tab--active {
  background: #ffffff;
  color: #17325c;
  box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);
}
.sales-product-analytics-dashboard__section {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  min-width: 0;
  align-self: stretch;
}
.sales-product-analytics-dashboard__section > .dashboard-section-header {
  width: 100%;
  box-sizing: border-box;
  align-self: stretch;
}
.sales-product-analytics-dashboard__section--inventory {
  gap: 12px;
}
.sales-product-analytics-dashboard__section .ant-spin-nested-loading, .sales-product-analytics-dashboard__section .ant-spin-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-self: stretch;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__overview-spin.ant-spin-nested-loading {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-shrink: 0;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__overview-spin.ant-spin-nested-loading .ant-spin-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__inventory-spin.ant-spin-nested-loading {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-shrink: 0;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__inventory-spin.ant-spin-nested-loading .ant-spin-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  align-items: stretch;
  gap: 16px;
}
.sales-product-analytics-dashboard__inventory-spin.ant-spin-nested-loading .ant-spin-container > :first-child {
  width: 100%;
  min-width: 0;
  align-self: stretch;
}
.sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__metric-card, .sales-product-analytics-dashboard__table-card {
  background: #ffffff;
  border: 1px solid hsla(220, 10%, 46%, 0.18);
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
  height: 100%;
}
.sales-product-analytics-dashboard__card {
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.sales-product-analytics-dashboard__card--sales-by-channel {
  min-width: 0;
  padding: 24px;
}
.sales-product-analytics-dashboard__table-card {
  padding: 0;
}
.sales-product-analytics-dashboard__overview-title {
  margin: 0;
  color: #101828;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.sales-product-analytics-dashboard__overview-subtitle {
  margin: 6px 0 0;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  line-height: 1.7;
}
.sales-product-analytics-dashboard__overview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 8;
  padding: 8px 0 14px;
  background: #ffffff;
  border-bottom: 1px solid rgba(23, 50, 92, 0.08);
}
.sales-product-analytics-dashboard__date-range {
  margin-left: auto;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__table-card {
  padding: 24px;
}
.sales-product-analytics-dashboard__metrics {
  display: grid;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  /* Three KPIs: flex splits row evenly (inline style also sets display flex on this node). */
}
.sales-product-analytics-dashboard__metrics--inventory > .dashboard-kpi-card {
  flex: 1 1;
  min-width: 0;
  max-width: none;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__metrics--inventory {
  gap: 22px !important;
}
.sales-product-analytics-dashboard__metrics--inventory > .dashboard-kpi-card {
  min-height: 122px;
  padding: 22px 22px;
  border-color: #e6edf7;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__title-row {
  margin-bottom: 4px;
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__title {
  color: #6b7280;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__value {
  color: #111827;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__description {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 7px;
  background: #edf5ff;
  color: #2b74e4;
}
.sales-product-analytics-dashboard__metrics--inventory .dashboard-kpi-card__icon svg {
  width: 21px;
  height: 21px;
}
.sales-product-analytics-dashboard__metrics--five {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.sales-product-analytics-dashboard__metrics--sales {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2.15fr) !important;
  margin-bottom: 18px;
}
@media (max-width: 1200px) {
  .sales-product-analytics-dashboard__metrics--sales {
    grid-template-columns: 1fr !important;
  }
}
.sales-product-analytics-dashboard__metrics--sales > .dashboard-kpi-card {
  min-height: 96px;
  padding: 16px 24px;
  gap: 8px;
}
.sales-product-analytics-dashboard__metrics--sales .dashboard-kpi-card__header {
  align-items: flex-start;
}
.sales-product-analytics-dashboard__metrics--sales .dashboard-kpi-card__title-row {
  margin-bottom: 10px;
}
.sales-product-analytics-dashboard__metrics--sales .dashboard-kpi-card__value {
  font-size: 22px;
  line-height: 1.15;
  margin-top: 20px;
}
.sales-product-analytics-dashboard__metrics--sales .dashboard-kpi-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}
.sales-product-analytics-dashboard__metrics--sales .dashboard-kpi-card__footer {
  margin-top: -2px;
}
.sales-product-analytics-dashboard__status-kpi-card.dashboard-kpi-card {
  min-width: 0;
  position: relative;
  overflow: visible;
}
.sales-product-analytics-dashboard__top-channel-kpi-card.dashboard-kpi-card {
  position: relative;
  overflow: visible;
}
.sales-product-analytics-dashboard__top-channel-value {
  position: relative;
  display: inline-flex;
  max-width: 100%;
  outline: none;
}
.sales-product-analytics-dashboard__top-channel-value:focus-visible {
  border-radius: 4px;
  box-shadow: 0 0 0 3px rgba(43, 104, 173, 0.16);
}
.sales-product-analytics-dashboard__top-channel-tooltip {
  position: absolute;
  z-index: 5;
  left: 50%;
  top: calc(100% + 14px);
  transform: translateX(-50%);
  display: grid;
  gap: 10px;
  width: 210px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
  color: #101828;
  pointer-events: none;
}
.sales-product-analytics-dashboard__top-channel-tooltip::after {
  content: "";
  position: absolute;
  left: 50%;
  top: -6px;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-left: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
}
.sales-product-analytics-dashboard__top-channel-tooltip-row {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}
.sales-product-analytics-dashboard__top-channel-tooltip-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}
.sales-product-analytics-dashboard__top-channel-tooltip-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.sales-product-analytics-dashboard__top-channel-tooltip strong {
  color: #1f2937;
  font-size: 16px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}
.sales-product-analytics-dashboard__status-kpi-card .dashboard-kpi-card__value {
  font-size: 14px;
}
.sales-product-analytics-dashboard__status-kpi {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sales-product-analytics-dashboard__status-kpi-bar {
  position: relative;
  display: flex;
  width: 100%;
  height: 12px;
  overflow: visible;
  border-radius: 4px;
  background: #eef2f7;
}
.sales-product-analytics-dashboard__status-kpi-segment {
  display: block;
  min-width: 0;
  height: 12px;
  cursor: pointer;
  transition: filter 0.16s ease, transform 0.16s ease;
}
.sales-product-analytics-dashboard__status-kpi-segment:first-child {
  border-radius: 4px 0 0 4px;
}
.sales-product-analytics-dashboard__status-kpi-segment:last-of-type {
  border-radius: 0 4px 4px 0;
}
.sales-product-analytics-dashboard__status-kpi-segment:hover, .sales-product-analytics-dashboard__status-kpi-segment:focus-visible {
  filter: brightness(0.95) saturate(1.12);
  outline: none;
}
.sales-product-analytics-dashboard__status-kpi-tooltip {
  z-index: 2000;
  max-width: calc(100vw - 32px);
  padding: 16px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
  color: #101828;
  pointer-events: none;
}
.sales-product-analytics-dashboard__status-kpi-tooltip::after {
  content: "";
  position: absolute;
  left: var(--status-tooltip-arrow-left, 50%);
  top: -6px;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-left: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
}
.sales-product-analytics-dashboard__status-kpi-tooltip-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__status-kpi-tooltip-description {
  display: block;
  margin-bottom: 16px;
  color: #7a8aa0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  white-space: normal;
}
.sales-product-analytics-dashboard__status-kpi-tooltip strong {
  display: block;
  color: #1f2937;
  font-size: 26px;
  line-height: 1;
  font-weight: 800;
}
.sales-product-analytics-dashboard__status-kpi-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}
.sales-product-analytics-dashboard__status-kpi-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.sales-product-analytics-dashboard__status-kpi-legend i {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
}
.sales-product-analytics-dashboard__sales-channel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__sales-channel-head .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__channel-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-top: 4px;
}
.sales-product-analytics-dashboard__channel-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.sales-product-analytics-dashboard__channel-toggle i {
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background: #c4c7cc;
  transition: background 0.2s ease;
}
.sales-product-analytics-dashboard__channel-toggle i::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18);
  transition: transform 0.2s ease;
}
.sales-product-analytics-dashboard__channel-toggle input:checked + i {
  background: #1f4e7d;
}
.sales-product-analytics-dashboard__channel-toggle input:checked + i::after {
  transform: translateX(18px);
}
.sales-product-analytics-dashboard__metrics.sales-product-analytics-dashboard__metrics--three {
  display: grid;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  justify-items: stretch;
}
.sales-product-analytics-dashboard__metrics.sales-product-analytics-dashboard__metrics--three > .dashboard-kpi-card {
  min-width: 0;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__metrics--customers {
  gap: 22px;
  margin-bottom: 18px;
}
.sales-product-analytics-dashboard__metrics--customers > .dashboard-kpi-card {
  min-height: 126px;
  padding: 24px 24px 22px;
  border-color: #dfe7f2;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 4px rgba(16, 24, 40, 0.08);
  gap: 8px;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__header {
  gap: 16px;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__title-row {
  margin-bottom: 3px;
  gap: 4px;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__title {
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  line-height: 1.25;
}
.sales-product-analytics-dashboard__metrics--customers .definition-tooltip__trigger {
  width: 13px;
  height: 13px;
  min-width: 13px;
  font-size: 8px;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__value {
  color: #0f172a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 7px;
  background: #eef5ff;
  color: #2b74e4;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__icon svg {
  width: 22px;
  height: 22px;
  stroke-width: 2.6;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__period {
  margin-top: 2px;
  gap: 3px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__change {
  gap: 2px;
  font-size: 11px;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__change svg {
  width: 12px;
  height: 12px;
  stroke-width: 3;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__change--positive {
  color: #12a855;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__change--negative {
  color: #e54848;
}
.sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__comparison {
  color: #98a2b3;
  font-size: 11px;
  font-weight: 700;
}
.sales-product-analytics-dashboard__metrics--overview {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  justify-items: stretch;
  align-items: stretch;
  align-self: stretch;
}
.sales-product-analytics-dashboard__metrics--overview > .dashboard-kpi-card {
  min-width: 0;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
}
.sales-product-analytics-dashboard__metrics--overview .dashboard-kpi-card__title {
  display: block;
  max-height: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sales-product-analytics-dashboard__metric-card {
  padding: 14px 20px;
}
.sales-product-analytics-dashboard__metric-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.sales-product-analytics-dashboard__metric-label {
  margin: 0;
  color: hsl(220, 10%, 46%);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: hsla(220, 10%, 46%, 0.08);
  color: #2b74e4;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__metric-icon-svg {
  width: 24px;
  height: 24px;
}
.sales-product-analytics-dashboard__metric-value {
  font-family: "opensans", sans-serif;
  color: #000000;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.sales-product-analytics-dashboard__metric-copy {
  margin: 8px 0 0;
  color: hsl(220, 10%, 46%);
  font-size: 13px;
  line-height: 1.6;
  font-weight: 500;
}
.sales-product-analytics-dashboard__metric-copy--positive {
  color: #198754;
}
.sales-product-analytics-dashboard__metric-copy--negative {
  color: #c33243;
}
.sales-product-analytics-dashboard__metric-copy-trend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sales-product-analytics-dashboard__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: stretch;
}
.sales-product-analytics-dashboard__grid--overview-charts {
  align-items: stretch;
}
.sales-product-analytics-dashboard__grid--top-products {
  align-items: start;
}
.sales-product-analytics-dashboard__card--overview-chart {
  min-height: 0;
}
.sales-product-analytics-dashboard__overview-chart-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__overview-chart-head .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__chart-wrap--overview {
  flex: 1 1 auto;
  width: 100%;
  height: 300px;
  min-height: 300px;
}
.sales-product-analytics-dashboard .recharts-surface {
  direction: ltr;
}
.sales-product-analytics-dashboard__chart-wrap--overview-pie {
  min-width: 0;
  justify-self: stretch;
  width: 100%;
}
.sales-product-analytics-dashboard__overview-channel-body {
  display: block;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}
.sales-product-analytics-dashboard__chart-wrap--overview-channel-bars {
  position: relative;
  width: 100%;
  height: clamp(230px, 48px * var(--overview-channel-rows, 6), 550px);
  min-height: 230px;
}
.sales-product-analytics-dashboard__chart-wrap--overview-channel-bars .recharts-wrapper,
.sales-product-analytics-dashboard__chart-wrap--overview-channel-bars .recharts-surface {
  width: 100% !important;
}
.sales-product-analytics-dashboard__channel-bar-label {
  fill: #0f172a;
  font-size: 12px;
  font-weight: 800;
  font-family: "opensans", sans-serif;
  font-variant-numeric: tabular-nums;
}
.sales-product-analytics-dashboard__channel-bar-label-percent {
  fill: #0f172a;
  font-size: 12px;
  font-weight: 800;
}
.sales-product-analytics-dashboard__bar-label {
  fill: #0f172a;
  font-size: 11px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
  font-variant-numeric: tabular-nums;
}
.sales-product-analytics-dashboard__channel-tooltip {
  min-width: 220px;
}
.sales-product-analytics-dashboard__channel-tooltip--compact {
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 280px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 10px 20px -4px rgba(15, 23, 42, 0.12);
}
.sales-product-analytics-dashboard__channel-tooltip--compact:has(.sales-product-analytics-dashboard__channel-tooltip-others-list--columns) {
  max-width: 560px;
}
.sales-product-analytics-dashboard__channel-tooltip--compact::before {
  content: "";
  position: absolute;
  top: -6px;
  left: var(--channel-tooltip-caret-left, 50%);
  transform: translateX(-50%);
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffffff;
  filter: drop-shadow(0 -1px 0 #e2e8f0);
}
.sales-product-analytics-dashboard__channel-tooltip-floating {
  position: absolute;
  z-index: 25;
  pointer-events: none;
  transform: translateY(0);
}
.sales-product-analytics-dashboard__channel-tooltip-single-row, .sales-product-analytics-dashboard__channel-tooltip-single-sales {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12px minmax(52px, auto);
  align-items: center;
  column-gap: 8px;
  font-size: 12px;
  line-height: 1.3;
}
.sales-product-analytics-dashboard__channel-tooltip-single-sales {
  grid-template-columns: minmax(0, 1fr) auto;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #edf2f7;
  color: #64748b;
}
.sales-product-analytics-dashboard__channel-tooltip-single-sales strong {
  color: #17325c;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.sales-product-analytics-dashboard__channel-tooltip-others-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sales-product-analytics-dashboard__channel-tooltip-others-list--columns {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(var(--others-tooltip-rows, 1), auto);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
  row-gap: 8px;
}
.sales-product-analytics-dashboard__channel-tooltip-others-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12px minmax(52px, auto);
  align-items: center;
  column-gap: 8px;
  font-size: 12px;
  line-height: 1.3;
  width: 100%;
}
.sales-product-analytics-dashboard__channel-tooltip-others-list--columns .sales-product-analytics-dashboard__channel-tooltip-others-row {
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) 12px minmax(44px, auto);
}
.sales-product-analytics-dashboard__channel-tooltip-others-swatch {
  width: 9px;
  height: 9px;
  border-radius: 1px;
  flex-shrink: 0;
  justify-self: center;
}
.sales-product-analytics-dashboard__channel-tooltip-others-name {
  color: #64748b;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__channel-tooltip-others-pct {
  color: #475569;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-align: left;
}
.sales-product-analytics-dashboard__legend-list--overview-channel {
  gap: 10px;
  margin: 0;
  align-self: center;
  justify-self: end;
  width: 100%;
  max-width: 100%;
}
.sales-product-analytics-dashboard__legend-row--channel-swatch {
  gap: 10px;
}
.sales-product-analytics-dashboard__legend-row-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
}
.sales-product-analytics-dashboard__legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}
.sales-product-analytics-dashboard__legend-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.sales-product-analytics-dashboard__legend-percent {
  flex-shrink: 0;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.sales-product-analytics-dashboard__grid--three {
  grid-template-columns: 1.15fr 0.85fr 0.85fr;
  min-width: 0;
}
.sales-product-analytics-dashboard__grid--three > * {
  min-width: 0;
}
.sales-product-analytics-dashboard__grid > *, .sales-product-analytics-dashboard__grid--three > * {
  align-self: stretch;
  height: 100%;
}
.sales-product-analytics-dashboard__card--full-span {
  grid-column: 1/-1;
}
.sales-product-analytics-dashboard__card--customer-segmentation {
  padding-top: 19px;
  padding-bottom: 19px;
}
.sales-product-analytics-dashboard__card--customer-segmentation .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 4px;
}
.sales-product-analytics-dashboard__card--customer-segmentation .customer-segmentation-kpi {
  margin-top: 0;
}
.sales-product-analytics-dashboard__card-title {
  margin: 0 0 14px;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
}
.sales-product-analytics-dashboard__title-with-tooltip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__table-card .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__title-with-tooltip .sales-product-analytics-dashboard__card-title {
  margin-bottom: 0;
  line-height: 1.25;
}
.sales-product-analytics-dashboard__title-with-tooltip .definition-tooltip {
  margin-top: 0;
  flex-shrink: 0;
  align-self: center;
}
.sales-product-analytics-dashboard__card-subtitle {
  margin: -6px 0 14px;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  line-height: 1.6;
}
.sales-product-analytics-dashboard__chart-wrap {
  width: 100%;
  height: 280px;
  min-height: 280px;
  position: relative;
  overflow: visible;
}
.sales-product-analytics-dashboard__chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.sales-product-analytics-dashboard__inventory-empty-state {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
}
.sales-product-analytics-dashboard__inventory-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #eef4ff;
  color: #2b74e4;
}
.sales-product-analytics-dashboard__inventory-empty-cell {
  height: 190px;
  padding: 18px 22px !important;
  text-align: center !important;
  vertical-align: middle !important;
}
.sales-product-analytics-dashboard__inventory-empty-cell .sales-product-analytics-dashboard__inventory-empty-state {
  display: flex;
  margin: 0 auto;
}
.sales-product-analytics-dashboard__inventory-chart-card {
  padding: 28px 28px 26px;
  border-radius: 8px;
}
.sales-product-analytics-dashboard__inventory-chart-card .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 4px;
}
.sales-product-analytics-dashboard__inventory-chart-card .sales-product-analytics-dashboard__card-subtitle {
  margin: 0 0 18px;
}
.sales-product-analytics-dashboard__inventory-chart-card .sales-product-analytics-dashboard__chart-wrap {
  height: 340px;
  min-height: 340px;
  margin-left: 0;
}
.sales-product-analytics-dashboard__threshold-overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: rgba(15, 23, 42, 0.35);
}
.sales-product-analytics-dashboard__threshold-control {
  position: relative;
  z-index: 45;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.sales-product-analytics-dashboard__inventory-header .dashboard-section-header__actions {
  margin-inline-start: auto;
  width: auto;
  justify-content: flex-end;
}
.sales-product-analytics-dashboard__inventory-header .sales-product-analytics-dashboard__threshold-control {
  width: auto;
  justify-content: flex-end;
}
.sales-product-analytics-dashboard__threshold-control label {
  margin: 0;
  color: #344054;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__threshold-input-wrap {
  position: relative;
  display: inline-flex;
}
.sales-product-analytics-dashboard__threshold-input-wrap input {
  width: 112px;
  height: 42px;
  padding: 0 38px 0 12px;
  border: 1px solid #cfd8e5;
  border-radius: 7px;
  background: #ffffff;
  color: #0f172a;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}
.sales-product-analytics-dashboard__threshold-input-wrap input:focus {
  border-color: #2b74e4;
  box-shadow: 0 0 0 3px rgba(43, 104, 173, 0.12);
}
.sales-product-analytics-dashboard__threshold-input-wrap input:disabled {
  background: #c7c7c7;
  border-color: #c7c7c7;
  color: #6f7480;
  cursor: not-allowed;
  opacity: 1;
}
.sales-product-analytics-dashboard__threshold-input-wrap input::-webkit-outer-spin-button, .sales-product-analytics-dashboard__threshold-input-wrap input::-webkit-inner-spin-button {
  margin: 0;
  appearance: none;
}
.sales-product-analytics-dashboard__threshold-input-wrap input[type=number] {
  appearance: textfield;
}
.sales-product-analytics-dashboard__threshold-commit-button {
  position: absolute;
  top: 50%;
  right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #2b74e4;
  color: #ffffff;
  cursor: pointer;
  transform: translateY(-50%);
  transition: background-color 0.16s ease, opacity 0.16s ease, transform 0.16s ease;
}
.sales-product-analytics-dashboard__threshold-commit-button:hover:not(:disabled) {
  background: #245a95;
}
.sales-product-analytics-dashboard__threshold-commit-button:active:not(:disabled) {
  transform: translateY(-50%) scale(0.96);
}
.sales-product-analytics-dashboard__threshold-commit-button:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}
.sales-product-analytics-dashboard__threshold-disabled-tooltip {
  position: absolute;
  top: calc(100% + 10px);
  right: 4px;
  z-index: 50;
  display: none;
  width: 258px;
  padding: 12px 14px;
  border-radius: 7px;
  background: #ffffff;
  color: #667085;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.16);
}
.sales-product-analytics-dashboard__threshold-disabled-tooltip::before, .sales-product-analytics-dashboard__threshold-confirm::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 28px;
  width: 16px;
  height: 16px;
  background: #ffffff;
  transform: rotate(45deg);
}
.sales-product-analytics-dashboard__threshold-input-wrap--disabled:hover .sales-product-analytics-dashboard__threshold-disabled-tooltip {
  display: block;
}
.sales-product-analytics-dashboard__threshold-confirm {
  position: absolute;
  top: calc(100% + 18px);
  right: 14px;
  z-index: 55;
  box-sizing: border-box;
  width: 402px;
  max-width: none;
  max-height: none;
  margin: 0;
  padding: 22px 18px 24px;
  border: none;
  border-radius: 7px;
  background: #ffffff;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.2);
}
.sales-product-analytics-dashboard__threshold-confirm p {
  position: relative;
  z-index: 1;
  margin: 0 0 18px;
  color: #667085;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}
.sales-product-analytics-dashboard__threshold-confirm div {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.sales-product-analytics-dashboard__threshold-confirm button {
  min-width: 60px;
  height: 38px;
  border: 1px solid #2b74e4;
  border-radius: 8px;
  background: #ffffff;
  color: #2b74e4;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.sales-product-analytics-dashboard__threshold-confirm button:last-child {
  background: #2b74e4;
  color: #ffffff;
}
.sales-product-analytics-dashboard__inventory-y-axis-tick {
  fill: #5f6b7a;
  font-size: 14px;
  font-weight: 500;
  text-anchor: start;
  dominant-baseline: middle;
}
.sales-product-analytics-dashboard__chart-wrap--sm {
  height: 220px;
  min-height: 220px;
}
.sales-product-analytics-dashboard__chart-wrap .recharts-responsive-container, .sales-product-analytics-dashboard__chart-wrap--sm .recharts-responsive-container {
  overflow: visible;
}
.sales-product-analytics-dashboard__chart-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 10px;
}
.sales-product-analytics-dashboard__chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}
.sales-product-analytics-dashboard__chart-legend-item--revenue {
  color: #2b74e4;
}
.sales-product-analytics-dashboard__chart-legend-item--expenses {
  color: #f6c15f;
}
.sales-product-analytics-dashboard__chart-legend-item--profit {
  color: #94d0b5;
}
.sales-product-analytics-dashboard__chart-legend-swatch {
  width: 10px;
  height: 10px;
  background: currentColor;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__summary-list, .sales-product-analytics-dashboard__legend-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sales-product-analytics-dashboard__summary-row, .sales-product-analytics-dashboard__legend-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.sales-product-analytics-dashboard__summary-row span:first-child, .sales-product-analytics-dashboard__legend-row span:first-child {
  color: hsl(220, 10%, 46%);
}
.sales-product-analytics-dashboard__summary-row span:last-child, .sales-product-analytics-dashboard__legend-row span:last-child {
  color: #173f76;
  font-weight: 700;
}
.sales-product-analytics-dashboard__summary-value--positive {
  color: #94d0b5 !important;
}
.sales-product-analytics-dashboard__summary-value--negative {
  color: #f6c15f !important;
}
.sales-product-analytics-dashboard__summary-value--warning {
  color: #8d4fd3 !important;
}
.sales-product-analytics-dashboard__summary-value--muted {
  color: hsl(220, 10%, 46%) !important;
}
.sales-product-analytics-dashboard__legend-row--center {
  justify-content: center;
  gap: 24px;
}
.sales-product-analytics-dashboard__legend-row--breakdown {
  margin-top: -2px;
}
.sales-product-analytics-dashboard__legend-label {
  font-size: 14px;
  line-height: 1.4;
}
.sales-product-analytics-dashboard__legend-label--muted {
  color: hsl(220, 10%, 46%);
  font-weight: 500;
}
.sales-product-analytics-dashboard__legend-label--strong {
  color: #173f76;
  font-weight: 700;
}
.sales-product-analytics-dashboard__legend-value--plain {
  color: #173f76;
  font-weight: 700;
  min-width: 24px;
  text-align: right;
}
.sales-product-analytics-dashboard__legend-row--segmentation {
  margin-top: 4px;
  gap: 28px;
}
.sales-product-analytics-dashboard__legend-dot-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  font-weight: 500;
}
.sales-product-analytics-dashboard__legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__filters--inline {
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__filters--stacked {
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  margin-bottom: 20px;
}
.sales-product-analytics-dashboard__search {
  min-width: 220px;
  flex: 1 1 220px;
}
.sales-product-analytics-dashboard__search--orders {
  min-width: 230px;
  flex: 0 0 230px;
}
.sales-product-analytics-dashboard__search--inventory {
  min-width: 260px;
  flex: 0 0 260px;
}
.sales-product-analytics-dashboard__search--customers {
  min-width: 260px;
  flex: 0 0 260px;
}
.sales-product-analytics-dashboard__select-menu {
  position: relative;
  min-width: 180px;
}
.sales-product-analytics-dashboard__select-menu--orders {
  min-width: 240px;
  width: 240px;
  flex: 0 0 240px;
}
.sales-product-analytics-dashboard__select-menu--inventory {
  min-width: 220px;
  width: 220px;
  flex: 0 0 220px;
}
.sales-product-analytics-dashboard__search--full, .sales-product-analytics-dashboard__select--full {
  width: 100%;
  min-width: 100%;
  flex: 0 0 auto;
}
.sales-product-analytics-dashboard__select--orders {
  width: 100%;
  min-width: 100%;
}
.sales-product-analytics-dashboard__select--inventory {
  width: 100%;
  min-width: 100%;
}
.sales-product-analytics-dashboard__search input, .sales-product-analytics-dashboard__select-trigger {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid hsla(220, 10%, 46%, 0.18);
  border-radius: 8px;
  background: #ffffff;
  color: #17325c;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.sales-product-analytics-dashboard__search input:focus, .sales-product-analytics-dashboard__select-trigger:focus {
  border-color: #2c68ad;
  box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.12);
}
.sales-product-analytics-dashboard__select-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px 0 18px;
  cursor: pointer;
  text-align: left;
}
.sales-product-analytics-dashboard__select-trigger span {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__select-trigger:hover {
  border-color: #cfd8e3;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}
.sales-product-analytics-dashboard__select-trigger--open {
  border-color: #cfd8e3;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);
}
.sales-product-analytics-dashboard__select-trigger-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__select-dropdown {
  position: fixed;
  z-index: 2000;
  min-width: 160px;
  max-height: 240px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 6px;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.sales-product-analytics-dashboard__select-dropdown--inventory-categories {
  max-height: min(180px, 100vh - 120px);
  overflow: hidden;
}
.sales-product-analytics-dashboard__select-dropdown-scroll {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}
.sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar {
  width: 6px;
}
.sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}
.sales-product-analytics-dashboard__select-dropdown-scroll--inventory-categories {
  max-height: min(180px, 100vh - 120px);
  padding-right: 10px;
  overscroll-behavior: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.sales-product-analytics-dashboard__select-dropdown-scroll--inventory-categories::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.sales-product-analytics-dashboard__select-dropdown-scrollbar {
  position: absolute;
  top: 8px;
  right: 6px;
  bottom: 8px;
  width: 8px;
  border-radius: 999px;
  background: #f3f6fb;
  pointer-events: none;
}
.sales-product-analytics-dashboard__select-dropdown-scrollbar-thumb {
  width: 100%;
  min-height: 24px;
  border-radius: 999px;
  background: #cbd5e1;
  transition: transform 0.12s ease-out;
}
.sales-product-analytics-dashboard__select-option {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.sales-product-analytics-dashboard__select-option:hover {
  background: #f2f2f2;
}
.sales-product-analytics-dashboard__select-option--active {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}
.sales-product-analytics-dashboard__select-option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #111827;
}
.sales-product-analytics-dashboard__table-wrap {
  overflow-x: auto;
}
.sales-product-analytics-dashboard__table-card.dashboard-data-table-panel {
  width: 100%;
  min-width: 0;
  overflow: visible;
  padding: 0;
}
.sales-product-analytics-dashboard__table-card.dashboard-data-table-panel .dashboard-data-table-scroll {
  max-width: 100%;
}
.sales-product-analytics-dashboard__table.dashboard-data-table {
  font-family: "opensans", sans-serif;
}
.sales-product-analytics-dashboard__table.dashboard-data-table th.dashboard-data-table__number,
.sales-product-analytics-dashboard__table.dashboard-data-table td.dashboard-data-table__number {
  text-align: left !important;
}
.sales-product-analytics-dashboard__table.dashboard-data-table th.dashboard-data-table__number .dashboard-data-table__sort {
  justify-content: flex-start !important;
  width: auto;
}
.sales-product-analytics-dashboard__order-row {
  cursor: pointer;
}
.sales-product-analytics-dashboard__order-row:hover td, .sales-product-analytics-dashboard__order-row:focus-visible td {
  background: #f8fbff;
}
.sales-product-analytics-dashboard__order-row:focus-visible {
  outline: 2px solid #2b68ad;
  outline-offset: -2px;
}
.sales-product-analytics-dashboard__order-panel-shell {
  position: fixed;
  inset: 0;
  z-index: 1400;
  pointer-events: none;
}
.sales-product-analytics-dashboard__order-panel-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(15, 23, 42, 0.48);
  cursor: default;
  pointer-events: auto;
}
.sales-product-analytics-dashboard__order-panel {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  display: flex;
  flex-direction: column;
  width: min(421px, 100vw);
  height: 100%;
  padding: 24px 20px 28px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 0 0 0 0px;
  box-shadow: -18px 0 36px rgba(15, 23, 42, 0.16);
  pointer-events: auto;
}
[dir=rtl] .sales-product-analytics-dashboard__order-panel {
  box-shadow: 18px 0 36px rgba(15, 23, 42, 0.16);
}
.sales-product-analytics-dashboard__order-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 30px;
  margin: 0 -20px 30px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #eef2f7;
}
.sales-product-analytics-dashboard__order-panel-eyebrow {
  margin: 0 0 5px;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__order-panel-header h3 {
  margin: 0 0 4px;
  color: #0f1f3d;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 900;
}
.sales-product-analytics-dashboard__order-panel-header span {
  color: #8b9ab1;
  font-size: 12px;
  font-weight: 600;
}
.sales-product-analytics-dashboard__order-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9aa6b8;
  cursor: pointer;
}
.sales-product-analytics-dashboard__order-panel-actions {
  display: flex;
  justify-content: flex-end;
  margin: 18px 0 4px;
}
.sales-product-analytics-dashboard__order-panel-export {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 128px;
  height: 38px;
  min-height: 0;
  padding: 0 14px;
  border: 1px solid #d9e2ef;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  box-shadow: none;
}
.sales-product-analytics-dashboard__order-panel-export svg {
  width: 12px;
  height: 12px;
  stroke-width: 2.5;
  color: #64748b;
}
.sales-product-analytics-dashboard__order-panel-export:hover, .sales-product-analytics-dashboard__order-panel-export:focus-visible {
  background: #f8fbff;
  border-color: #c7d7ee;
}
.sales-product-analytics-dashboard__order-panel-section {
  padding: 0 0 30px;
  border-bottom: 0;
}
.sales-product-analytics-dashboard__order-panel-section h4 {
  margin: 0 0 20px;
  color: #98a6bd;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__order-panel-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}
.sales-product-analytics-dashboard__order-panel-section-head h4 {
  margin: 0;
}
.sales-product-analytics-dashboard__order-products {
  display: grid;
  gap: 14px;
}
.sales-product-analytics-dashboard__order-product {
  display: grid;
  grid-template-columns: 60px minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  min-height: 96px;
  padding: 14px 16px;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03);
}
.sales-product-analytics-dashboard__order-product-image {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  overflow: hidden;
  border-radius: 8px;
  background: #f1f4f8;
  color: #93a3b8;
}
.sales-product-analytics-dashboard__order-product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sales-product-analytics-dashboard__order-product-main {
  min-width: 0;
}
.sales-product-analytics-dashboard__order-product-main strong {
  display: block;
  color: #111827;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 900;
}
.sales-product-analytics-dashboard__order-product-main > span {
  display: block;
  margin-top: 3px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
}
.sales-product-analytics-dashboard__order-product-price {
  margin-top: 9px !important;
  color: #111827 !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}
.sales-product-analytics-dashboard__order-product-qty {
  align-self: end;
  padding-bottom: 5px;
  color: #7f93b4;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__order-detail-list {
  display: grid;
  gap: 16px;
  margin: 0;
}
.sales-product-analytics-dashboard__order-detail-list div {
  display: grid;
  grid-template-columns: minmax(110px, 0.7fr) minmax(0, 1fr);
  gap: 12px;
  align-items: baseline;
}
.sales-product-analytics-dashboard__order-detail-list dt {
  color: #6b7a92;
  font-size: 13px;
  font-weight: 700;
}
.sales-product-analytics-dashboard__order-detail-list dd {
  min-width: 0;
  margin: 0;
  color: #111827;
  font-size: 13px;
  font-weight: 500;
  overflow-wrap: anywhere;
  text-align: right;
}
.sales-product-analytics-dashboard__order-detail-list-total {
  padding-top: 6px;
  border-top: 1px solid #eef2f7;
}
.sales-product-analytics-dashboard__order-detail-list-total dt,
.sales-product-analytics-dashboard__order-detail-list-total dd {
  color: #111827;
  font-size: 15px;
  font-weight: 900;
}
.sales-product-analytics-dashboard__order-detail-list-total dd {
  color: #2b74e4;
  font-weight: 900;
}
.sales-product-analytics-dashboard__order-detail-list-status {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start;
  gap: 8px !important;
}
.sales-product-analytics-dashboard__order-detail-list-status dt {
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__order-detail-list-status dd {
  text-align: left;
}
.sales-product-analytics-dashboard__order-detail-list-status + div {
  display: none;
}
.sales-product-analytics-dashboard__order-status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 16px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #eef2f7;
  color: #475569;
  font-size: 9px;
  font-weight: 900;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__order-status-badge--paid {
  background: #d9fbe8;
  color: #179b54;
}
.sales-product-analytics-dashboard__order-status-badge--pending {
  background: #fff3d6;
  color: #b45309;
}
.sales-product-analytics-dashboard__order-detail-list--customer {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
  row-gap: 18px;
}
.sales-product-analytics-dashboard__order-detail-list--customer div {
  display: block;
}
.sales-product-analytics-dashboard__order-detail-list--customer dt {
  margin-bottom: 4px;
  font-size: 11px;
  color: #98a6bd;
}
.sales-product-analytics-dashboard__order-detail-list--customer dd {
  text-align: left;
  font-size: 13px;
  line-height: 1.35;
}
.sales-product-analytics-dashboard__order-panel-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 220px;
  color: #667085;
  font-size: 14px;
  font-weight: 700;
}
.sales-product-analytics-dashboard__order-panel-state--error, .sales-product-analytics-dashboard__order-panel-empty {
  color: #b42318;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table {
  width: 100%;
  min-width: max-content;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table th .definition-tooltip {
  margin-left: 7px;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table th .dashboard-data-table__sort {
  letter-spacing: inherit;
  line-height: inherit;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table th.sales-product-analytics-dashboard__tooltip-header {
  position: relative;
  overflow: visible;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table th.sales-product-analytics-dashboard__tooltip-header:has(.definition-tooltip:hover),
.sales-product-analytics-dashboard__table--customers.dashboard-data-table th.sales-product-analytics-dashboard__tooltip-header:has(.definition-tooltip:focus-within) {
  z-index: 20;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table thead th {
  padding: 18px 22px 14px;
  background: #f8fafc;
  color: #65758f;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.55;
  text-transform: uppercase;
  border-bottom-color: #edf2f7;
  white-space: normal;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table tbody td {
  padding: 16px 22px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  border-top-color: #eef2f7;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table tbody tr:hover td {
  background: #fbfdff;
}
.sales-product-analytics-dashboard__table--customers.dashboard-data-table .dashboard-data-table__cell--emphasis {
  color: #1e293b;
  font-weight: 700;
}
.sales-product-analytics-dashboard__table-card--top-products {
  padding: 20px 0 0;
  min-width: 0;
}
.sales-product-analytics-dashboard__table-card--top-products .dashboard-data-table-panel__header {
  min-height: 0;
  padding: 14px 24px 12px;
  align-items: center;
  justify-content: flex-start;
}
.sales-product-analytics-dashboard__table-card--top-products .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__table-card--top-products .dashboard-data-table-scroll {
  padding: 0 24px 20px;
}
.sales-product-analytics-dashboard__table-card--orders {
  padding: 22px 0 20px;
}
.sales-product-analytics-dashboard__table-card--inventory {
  padding: 22px 0 20px;
  margin-top: 14px;
}
.sales-product-analytics-dashboard__inventory-insights-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin: 8px 0;
}
.sales-product-analytics-dashboard__inventory-insights-header .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 2px;
}
.sales-product-analytics-dashboard__inventory-insights-header .sales-product-analytics-dashboard__card-subtitle {
  margin: 0;
}
.sales-product-analytics-dashboard__inventory-tools {
  flex: 0 1 auto;
  min-width: min(100%, 606px);
  gap: 8px;
  padding-bottom: 0;
}
.sales-product-analytics-dashboard__inventory-tools .dashboard-data-table-panel__search {
  flex: 0 0 300px;
  width: 300px;
  max-width: 300px;
  min-width: 300px !important;
  height: 40px;
  padding: 0 12px;
}
.sales-product-analytics-dashboard__inventory-tools .dashboard-data-table-panel__search input {
  font-size: 13px;
  padding-left: 8px;
}
.sales-product-analytics-dashboard__inventory-tools .sales-product-analytics-dashboard__select-menu--inventory {
  flex: 0 0 145px;
  width: 145px;
  min-width: 145px;
  max-width: 145px;
}
.sales-product-analytics-dashboard__inventory-tools .sales-product-analytics-dashboard__select-trigger {
  height: 40px;
  padding: 0 12px;
  font-size: 13px;
}
.sales-product-analytics-dashboard__select-menu--inventory-table {
  flex: 0 0 145px;
  width: 145px;
  min-width: 145px;
  max-width: 145px;
}
.sales-product-analytics-dashboard__select-menu--inventory-table .sales-product-analytics-dashboard__select-trigger {
  height: 40px;
  padding: 0 12px;
  font-size: 13px;
}
.sales-product-analytics-dashboard__table-card--customers {
  padding: 22px 0 20px;
}
.sales-product-analytics-dashboard__table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 24px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__panel-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2px;
}
.sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search {
  min-width: 0 !important;
  flex: 0 0 52%;
  width: 52%;
  max-width: 52%;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools, .sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__panel-tools, .sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__panel-tools {
  overflow: visible;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__panel-tools {
  margin-inline-start: auto;
  flex: 0 1 auto;
  justify-content: flex-end;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search {
  flex: 0 0 auto;
  width: auto;
  min-width: 180px;
  max-width: 290px;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search {
  flex: 0 0 290px;
  width: 290px;
  max-width: 290px;
  height: 42px;
}
.sales-product-analytics-dashboard__export-menu {
  position: relative;
  flex: 0 0 auto;
}
.sales-product-analytics-dashboard__export-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  height: 48px;
  padding: 0 18px;
  border: 1px solid #d7e1ee;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}
.sales-product-analytics-dashboard__export-button:hover:not(:disabled) {
  border-color: #cbd5e1;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}
.sales-product-analytics-dashboard__export-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.sales-product-analytics-dashboard__export-button--loading:disabled {
  opacity: 1;
}
.sales-product-analytics-dashboard__export-loader {
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__export-button {
  height: 42px;
  min-width: 114px;
  padding: 0 18px;
}
.sales-product-analytics-dashboard__export-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 124px;
  padding: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
}
.sales-product-analytics-dashboard__export-dropdown button {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}
.sales-product-analytics-dashboard__export-dropdown button:hover {
  background: #f8fafc;
}
.sales-product-analytics-dashboard__select-menu--toolbar {
  flex: 0 0 auto;
  min-width: min(128px, 22vw);
  max-width: 200px;
}
.sales-product-analytics-dashboard__panel-tools .sales-product-analytics-dashboard__select-menu--toolbar.sales-product-analytics-dashboard__select-menu--orders, .sales-product-analytics-dashboard__panel-tools .sales-product-analytics-dashboard__select-menu--toolbar.sales-product-analytics-dashboard__select-menu--inventory {
  width: min(168px, 30vw);
  min-width: min(120px, 22vw);
  flex: 0 0 auto;
}
.sales-product-analytics-dashboard__table-card--orders.dashboard-data-table-panel .dashboard-data-table-panel__header, .sales-product-analytics-dashboard__table-card--inventory.dashboard-data-table-panel .dashboard-data-table-panel__header, .sales-product-analytics-dashboard__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {
  flex-wrap: nowrap;
  min-height: 0;
  padding-top: 28px;
  padding-bottom: 28px;
  gap: 10px;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 8px;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__card-subtitle {
  margin: 0;
}
.sales-product-analytics-dashboard__table-card--orders .dashboard-data-table-panel__header > :first-child, .sales-product-analytics-dashboard__table-card--inventory .dashboard-data-table-panel__header > :first-child, .sales-product-analytics-dashboard__table-card--customers .dashboard-data-table-panel__header > :first-child {
  flex: 0 1 auto;
  min-width: 0;
}
.sales-product-analytics-dashboard__table-card--inventory .dashboard-data-table-panel__header .sales-product-analytics-dashboard__title-with-tooltip, .sales-product-analytics-dashboard__table-card--customers .dashboard-data-table-panel__header .sales-product-analytics-dashboard__title-with-tooltip {
  min-width: 0;
  max-width: min(100%, 340px);
}
.sales-product-analytics-dashboard__table-card--inventory .dashboard-data-table-panel__header .sales-product-analytics-dashboard__card-title, .sales-product-analytics-dashboard__table-card--customers .dashboard-data-table-panel__header .sales-product-analytics-dashboard__card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__orders-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  min-width: 0;
}
.sales-product-analytics-dashboard__orders-heading .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__orders-count {
  margin: 0;
  color: #7a8aa0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
}
.sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__table thead th {
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__table thead th .dashboard-data-table__sort {
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table--overview th, .sales-product-analytics-dashboard__table--overview td {
  padding-left: 24px;
  padding-right: 24px;
}
.sales-product-analytics-dashboard__table--top-products th, .sales-product-analytics-dashboard__table--top-products td {
  padding-left: 12px;
  padding-right: 12px;
}
.sales-product-analytics-dashboard__table--top-products th {
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__table--top-products th:first-child, .sales-product-analytics-dashboard__table--top-products td:first-child {
  padding-left: 0;
}
.sales-product-analytics-dashboard__table--top-products th:last-child, .sales-product-analytics-dashboard__table--top-products td:last-child {
  padding-right: 0;
}
.sales-product-analytics-dashboard__table--top-products tbody tr:last-child td {
  border-bottom: 0;
}
.sales-product-analytics-dashboard__product-image-heading, .sales-product-analytics-dashboard__product-image-cell {
  width: 44px;
}
.sales-product-analytics-dashboard__product-image-frame {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f8fafc;
  overflow: hidden;
  color: #94a3b8;
  position: relative;
  vertical-align: middle;
}
.sales-product-analytics-dashboard__product-image-frame--unavailable {
  overflow: visible;
  border: 0;
  background: transparent;
}
.sales-product-analytics-dashboard__product-image-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sales-product-analytics-dashboard__product-image-placeholder {
  width: 15px;
  height: 15px;
}
.sales-product-analytics-dashboard__product-image-unavailable {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  outline: none;
}
.sales-product-analytics-dashboard__product-image-question {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #eef5ff;
  color: #2b6cb0;
  font-size: 22px;
  font-weight: 500;
  line-height: 1;
}
.sales-product-analytics-dashboard__product-image-tooltip {
  position: absolute;
  top: calc(100% + 12px);
  left: -10px;
  z-index: 30;
  display: none;
  min-width: 208px;
  padding: 11px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__product-image-tooltip::before {
  content: "";
  position: absolute;
  top: -7px;
  left: 24px;
  width: 14px;
  height: 14px;
  border-top: 1px solid #e5e7eb;
  border-left: 1px solid #e5e7eb;
  background: #ffffff;
  transform: rotate(45deg);
}
.sales-product-analytics-dashboard__product-image-unavailable:hover .sales-product-analytics-dashboard__product-image-tooltip, .sales-product-analytics-dashboard__product-image-unavailable:focus .sales-product-analytics-dashboard__product-image-tooltip {
  display: block;
}
.sales-product-analytics-dashboard__product-name {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.sales-product-analytics-dashboard__pill, .sales-product-analytics-dashboard__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
.sales-product-analytics-dashboard__status {
  min-height: 18px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__pill {
  min-width: 48px;
  padding: 7px 12px;
  background: #2b74e4;
  color: #ffffff;
}
.sales-product-analytics-dashboard__customer-segments {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 270px;
}
.sales-product-analytics-dashboard__segment-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 118px;
  min-height: 24px;
  padding: 6px 10px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sales-product-analytics-dashboard__segment-chip--loyal, .sales-product-analytics-dashboard__segment-chip--default {
  background: #2563eb;
}
.sales-product-analytics-dashboard__segment-chip--high-spenders {
  background: #2dd4bf;
}
.sales-product-analytics-dashboard__segment-chip--idle {
  background: #a855f7;
}
.sales-product-analytics-dashboard__segment-chip--unsubscribed {
  background: #60a5fa;
}
.sales-product-analytics-dashboard__segment-chip--one-timers {
  background: #10b981;
}
.sales-product-analytics-dashboard__segment-chip--cart-abandoners {
  background: #ea580c;
}
.sales-product-analytics-dashboard__segment-chip--indecisive {
  background: #f59e0b;
}
.sales-product-analytics-dashboard__segment-more {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #2f74c7;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  cursor: default;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__segment-more:hover .sales-product-analytics-dashboard__segment-tooltip, .sales-product-analytics-dashboard__segment-more:focus-within .sales-product-analytics-dashboard__segment-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 8px);
}
.sales-product-analytics-dashboard__segment-tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  z-index: 35;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: max-content;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.16);
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, 2px);
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
}
.sales-product-analytics-dashboard__segment-tooltip::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-left: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
  transform: translateX(-50%) rotate(45deg);
}
.sales-product-analytics-dashboard__status--completed, .sales-product-analytics-dashboard__status--fulfilled, .sales-product-analytics-dashboard__status--returning, .sales-product-analytics-dashboard__status--enabled, .sales-product-analytics-dashboard__status--in_stock {
  background: #198754;
  color: #fff;
}
.sales-product-analytics-dashboard__status--pending, .sales-product-analytics-dashboard__status--unfulfilled, .sales-product-analytics-dashboard__status--partial, .sales-product-analytics-dashboard__status--new, .sales-product-analytics-dashboard__status--invited, .sales-product-analytics-dashboard__status--low_stock {
  background: #f05a0a;
  color: #fff;
}
.sales-product-analytics-dashboard__status--refunded, .sales-product-analytics-dashboard__status--cancelled, .sales-product-analytics-dashboard__status--disabled, .sales-product-analytics-dashboard__status--out_of_stock {
  background: #c33243;
  color: #fff;
}
.sales-product-analytics-dashboard__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 16px 20px 2px;
}
.sales-product-analytics-dashboard__pagination-copy {
  color: hsl(220, 10%, 46%);
  font-size: 14px;
}
.sales-product-analytics-dashboard__pagination-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.sales-product-analytics-dashboard__pagination-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #94a3b8;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease;
}
.sales-product-analytics-dashboard__pagination-controls button:hover:not(:disabled) {
  background: hsla(220, 10%, 46%, 0.08);
}
.sales-product-analytics-dashboard__pagination-controls button:disabled {
  opacity: 0.45;
  color: #94a3b8;
  cursor: not-allowed;
}
.sales-product-analytics-dashboard__financial-bars {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.sales-product-analytics-dashboard__financial-bar-copy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  color: #17325c;
  font-size: 14px;
}
.sales-product-analytics-dashboard__financial-bar-track {
  height: 10px;
  border-radius: 999px;
  background: hsla(220, 10%, 46%, 0.08);
  overflow: hidden;
}
.sales-product-analytics-dashboard__financial-bar-fill {
  height: 100%;
  border-radius: 999px;
  background: #2b74e4;
}
@media (max-width: 1200px) {
  .sales-product-analytics-dashboard__metrics:not(.sales-product-analytics-dashboard__metrics--overview):not(.sales-product-analytics-dashboard__metrics--inventory):not(.sales-product-analytics-dashboard__metrics--three) {
    grid-template-columns: 1fr;
  }
  .sales-product-analytics-dashboard__metrics.sales-product-analytics-dashboard__metrics--three {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sales-product-analytics-dashboard__metrics--inventory {
    flex-direction: column !important;
  }
  .sales-product-analytics-dashboard__metrics--inventory > .dashboard-kpi-card {
    width: 100%;
  }
  .sales-product-analytics-dashboard__metrics--overview {
    grid-template-columns: 1fr !important;
  }
  .sales-product-analytics-dashboard__grid, .sales-product-analytics-dashboard__grid--three {
    grid-template-columns: 1fr;
  }
  .sales-product-analytics-dashboard__overview-channel-body {
    grid-template-columns: 1fr;
    justify-items: stretch;
  }
  .sales-product-analytics-dashboard__legend-list--overview-channel {
    align-self: stretch;
    max-width: none;
  }
}
@media (max-width: 768px) {
  .sales-product-analytics-dashboard {
    width: 100%;
  }
  .sales-product-analytics-dashboard__tabs {
    padding: 6px;
    gap: 6px;
  }
  .sales-product-analytics-dashboard__tab {
    width: 100%;
    text-align: left;
    padding: 12px 16px;
  }
  .sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__metric-card, .sales-product-analytics-dashboard__table-card {
    padding: 20px;
    border-radius: 18px;
  }
  .sales-product-analytics-dashboard__overview-title {
    font-size: 24px;
  }
  .sales-product-analytics-dashboard__overview-header {
    flex-direction: column;
    align-items: stretch;
  }
  .sales-product-analytics-dashboard__date-range {
    width: 100%;
    margin-left: 0;
  }
  .sales-product-analytics-dashboard__date-range .organic-range-picker {
    width: 100%;
  }
  .sales-product-analytics-dashboard__date-range .organic-range-picker__control {
    width: 100%;
  }
  .sales-product-analytics-dashboard__metrics.sales-product-analytics-dashboard__metrics--three {
    grid-template-columns: 1fr;
  }
  .sales-product-analytics-dashboard__metrics--customers {
    gap: 14px;
  }
  .sales-product-analytics-dashboard__metrics--customers > .dashboard-kpi-card {
    min-height: 118px;
    padding: 20px;
  }
  .sales-product-analytics-dashboard__metrics--customers .dashboard-kpi-card__value {
    font-size: 28px;
  }
  .sales-product-analytics-dashboard__metric-value {
    font-size: 24px;
  }
  .sales-product-analytics-dashboard__pagination {
    flex-direction: column;
    align-items: flex-start;
  }
  .sales-product-analytics-dashboard__table-header {
    flex-direction: column;
    align-items: stretch;
    padding: 0 20px;
  }
  .sales-product-analytics-dashboard__filters--inline {
    flex-wrap: wrap;
    justify-content: stretch;
  }
  .sales-product-analytics-dashboard__inventory-insights-header {
    flex-direction: column;
    align-items: stretch;
  }
  .sales-product-analytics-dashboard__inventory-tools {
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
    justify-content: stretch;
  }
  .sales-product-analytics-dashboard__threshold-control {
    width: 100%;
    justify-content: space-between;
  }
  .sales-product-analytics-dashboard__threshold-confirm {
    right: 0;
    width: min(402px, 100vw - 40px);
  }
  .sales-product-analytics-dashboard__search--orders, .sales-product-analytics-dashboard__search--inventory, .sales-product-analytics-dashboard__search--customers, .sales-product-analytics-dashboard__select-menu--orders, .sales-product-analytics-dashboard__select-menu--inventory, .sales-product-analytics-dashboard__select-menu--inventory-table {
    width: 100%;
    min-width: 100%;
    flex: 1 1 100%;
  }
  .sales-product-analytics-dashboard__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {
    flex-wrap: wrap;
    align-items: stretch;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools {
    width: 100%;
    flex-wrap: wrap;
    justify-content: stretch;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search, .sales-product-analytics-dashboard__export-menu, .sales-product-analytics-dashboard__export-button {
    width: 100%;
    max-width: none;
    flex: 1 1 100%;
  }
}
@media (max-width: 1100px) {
  .sales-product-analytics-dashboard__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools {
    margin-inline-start: auto;
    flex: 0 1 auto;
    flex-wrap: nowrap;
    width: auto;
    justify-content: flex-end;
  }
}
@media (max-width: 768px) {
  .sales-product-analytics-dashboard__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools {
    width: auto;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search {
    width: auto;
    min-width: 180px;
    max-width: 290px;
    flex: 0 1 auto;
  }
  .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__export-menu, .sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__export-button {
    width: auto;
    min-width: 0;
    max-width: none;
    flex: 0 0 auto;
  }
}
@media (min-width: 800px) and (max-width: 1024px) {
  .sales-product-analytics-dashboard .dashboard-section-header__actions {
    justify-content: flex-end;
  }
}
@media (min-width: 600px) and (max-width: 1100px) {
  .sales-product-analytics-dashboard__table-card--inventory.dashboard-data-table-panel .dashboard-data-table-panel__header {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
  }
  .sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__select-menu--inventory-table {
    width: 145px;
    min-width: 145px;
    max-width: 145px;
    flex: 0 0 auto;
  }
}

/* Active tab panel scrolls; pill tabs stay fixed (dashboard route shell) */
.sales-product-analytics-dashboard > *:not(.sales-product-analytics-dashboard__tabs) {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.spa-trend-granularity {
  display: inline-flex;
  padding: 2px;
  border-radius: 8px;
  background: #edf3fb;
  gap: 2px;
  align-self: center;
}

.spa-trend-granularity__btn {
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  cursor: pointer;
}

.spa-trend-granularity__btn--active {
  background: #ffffff;
  color: #000000;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.spa-trend-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 4px 4px;
}

.spa-trend-pagination__label {
  color: #7b8797;
  font-size: 13px;
  font-weight: 500;
}

.spa-trend-pagination__nav {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spa-trend-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #dce3ed;
  border-radius: 7px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.spa-trend-pagination__btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #334155;
}
.spa-trend-pagination__btn:disabled {
  color: #cbd5e1;
  cursor: not-allowed;
  opacity: 0.8;
}

.sales-attribution__filter-bar-clear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 14px;
  min-height: 48px;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.sales-attribution__filter-bar-clear-text {
  padding-left: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/salesProductAnalytics/components/SalesProductAnalyticsTabsDashboard.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAWhB;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;EAsGA,kFAAA;EAwcA;wFAAA;EAkHA,wGAAA;EAsIA;;;;;;;IAAA;EAokBA,iFAAA;EA6XA,sHAAA;AAluDF;AAHE;EACE,oBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCA5B0B;EA6B1B,kBAAA;EACA,eAAA;EACA,cAAA;AAKJ;AAFE;EACE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAxC6B;EAyC7B,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uEAAA;AAIJ;AAFI;EACE,qCAAA;EACA,cAAA;AAIN;AAAE;EACE,mBAAA;EACA,cAAA;EACA,8CAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACJ;AAEE;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,SAAA;AADJ;AAIE;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAHJ;AAME;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAJJ;AAOE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AALJ;AAQE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AANJ;AASE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AAPJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AATJ;AAYE;EAGE,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,4CAAA;EACA,YAAA;AAZJ;AAeE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAbJ;AAgBE;EACE,YAAA;EACA,aAAA;AAdJ;AAiBE;EACE,UAAA;AAfJ;AAkBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,yBArK6B;EAsK7B,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;AAlBJ;AAqBE;EACE,iBAAA;EACA,cAAA;AAnBJ;AAsBE;EAEE,aAAA;AArBJ;AAwBE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,gDAAA;EACA,SAAA;EAEA,2FAAA;AAvBJ;AAyBM;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AAvBR;AA4BE;EACE,oBAAA;AA1BJ;AA6BE;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,4CAAA;AA3BJ;AA8BE;EACE,kBAAA;AA5BJ;AA+BE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA7BJ;AAgCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cA7P0B;AA6N9B;AAmCE;EACE,WAAA;EACA,YAAA;AAjCJ;AAoCE;EACE,gDAAA;AAlCJ;AAqCE;EACE,iFAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE;IACE,qCAAA;EApCJ;AACF;AAuCE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;AArCJ;AAwCE;EACE,uBAAA;AAtCJ;AAyCE;EACE,mBAAA;AAvCJ;AA0CE;EACE,eAAA;EACA,iBAAA;EACI,gBAAA;AAxCR;AA2CE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;AA6CE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AA3CJ;AA8CE;EACE,kBAAA;EACA,iBAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;AA7CJ;AAgDE;EACE,kBAAA;EACA,8CAAA;AA9CJ;AAiDE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,cAAA;EACA,oBAAA;AA/CJ;AAkDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;AAhDJ;AAmDE;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAjDJ;AAoDE;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,kDAAA;AAlDJ;AAqDE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AAnDJ;AAsDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AApDJ;AAuDE;EACE,eAAA;AArDJ;AAwDE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAtDJ;AAyDE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAvDJ;AA0DE;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mDAAA;AAxDJ;AA2DE;EACE,0BAAA;AAzDJ;AA4DE;EACE,0BAAA;AA1DJ;AA6DE;EAEE,uCAAA;EACA,aAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,cAAA;EACA,oBAAA;AA7DJ;AAgEE;EACE,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,SAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;AA9DJ;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA/DJ;AAkEE;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjEJ;AAoEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlEJ;AAqEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAnEJ;AAsEE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AApEJ;AAuEE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AArEJ;AAwEE;EACE,gBAAA;AAtEJ;AAyEE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;AAvEJ;AA0EE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAxEJ;AA2EE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,+BAAA;AA1EJ;AA6EE;EACE,mBAAA;AA3EJ;AA8EE;EACE,2BAAA;AA5EJ;AAiFE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,gDAAA;EACA,SAAA;EACA,sBAAA;AA/EJ;AAkFE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAhFJ;AAmFE;EACE,SAAA;EACA,mBAAA;AAjFJ;AAoFE;EACE,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,8EACE;EAEF,QAAA;AApFJ;AAuFE;EACE,SAAA;AArFJ;AAwFE;EACE,kBAAA;EACA,QAAA;AAtFJ;AAyFE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AAvFJ;AA0FE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAxFJ;AA2FE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzFJ;AA4FE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAxoB0B;AA8iB9B;AA6FE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3FJ;AA8FE;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA5FJ;AA+FE;EACE,QAAA;EACA,eAAA;AA7FJ;AAgGE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA9FJ;AAiGE;EACE,cAAA;AA/FJ;AAkGE;EACE,cAAA;AAhGJ;AAmGE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjGJ;AAqGE;EACE,gDAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;AAnGJ;AAsGE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AApGJ;AA4GE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA1GJ;AA6GE;EACE,kBAAA;AA3GJ;AA8GE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5GJ;AA+GE;EACE,SAAA;EACA,yBA9tB6B;EA+tB7B,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA7GJ;AAgHE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCA1uB0B;EA2uB1B,cA1uB0B;EA2uB1B,cAAA;AA9GJ;AAiHE;EACE,WAAA;EACA,YAAA;AA/GJ;AAkHE;EACE,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhHJ;AAmHE;EACE,eAAA;EACA,yBAhwB6B;EAiwB7B,eAAA;EACA,gBAAA;EACA,gBAAA;AAjHJ;AAoHE;EACE,cAAA;AAlHJ;AAqHE;EACE,cAAA;AAnHJ;AAsHE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AApHJ;AAuHE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;AArHJ;AAwHE;EACE,oBAAA;AAtHJ;AAyHE;EACE,kBAAA;AAvHJ;AA0HE;EACE,aAAA;AAxHJ;AA2HE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAzHJ;AA2HI;EACE,gBAAA;AAzHN;AA6HE;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;AA3HJ;AAsIE;EACE,cAAA;AApIJ;AAuIE;EACE,YAAA;EACA,qBAAA;EACA,WAAA;AArIJ;AAwIE;EACE,cAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAtIJ;AAyIE;EACE,kBAAA;EACA,WAAA;EACA,mEAAA;EACA,iBAAA;AAvIJ;AAyII;;EAEE,sBAAA;AAvIN;AA2IE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AAzIJ;AA4IE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AA1IJ;AA6IE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;AA3IJ;AA8IE;EACE,gBAAA;AA5IJ;AA+IE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0FACE;AA9IN;AAiJI;EACE,gBAAA;AA/IN;AAkJI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,4CAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;AAhJN;AAoJE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;AAlJJ;AAqJE;EAEE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AApJJ;AAuJE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AArJJ;AAuJI;EACE,cAAA;EACA,gBAAA;EACA,kCAAA;AArJN;AAyJE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAvJJ;AA0JE;EACE,aAAA;EACA,sBAAA;EACA,+DAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;AAxJJ;AA2JE;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAzJJ;AA4JE;EACE,YAAA;EACA,6DAAA;AA1JJ;AA6JE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AA3JJ;AA8JE;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5JJ;AA+JE;EACE,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AA7JJ;AAgKE;EACE,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AA9JJ;AAiKE;EACE,SAAA;AA/JJ;AAkKE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AAhKJ;AAmKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kDAAA;AAjKJ;AAoKE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAlKJ;AAqKE;EACE,cAAA;EACA,iBAAA;EACA,kCAAA;AAnKJ;AAsKE;EACE,2CAAA;EACA,YAAA;AApKJ;AAuKE;EACE,YAAA;AArKJ;AAwKE;EAEE,mBAAA;EACA,YAAA;AAvKJ;AA0KE;EACE,iBAAA;AAxKJ;AA2KE;EACE,iBAAA;EACA,oBAAA;AAzKJ;AA4KE;EACE,kBAAA;AA1KJ;AA6KE;EACE,aAAA;AA3KJ;AA8KE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AA5KJ;AA+KE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA7KJ;AAgLE;EACE,gBAAA;AA9KJ;AAiLE;EACE,gBAAA;EACA,iBAAA;AA/KJ;AAkLE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AAhLJ;AAmLE;EACE,mBAAA;EACA,yBA5lC6B;EA6lC7B,eAAA;EACA,gBAAA;AAjLJ;AAoLE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAlLJ;AAqLE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAnLJ;AAsLE;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AApLJ;AAuLE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAvoC0B;AAk9B9B;AAwLE;EACE,aAAA;EACA,6BAAA;EACA,6BAAA;EACA,iCAAA;AAtLJ;AAyLE;EACE,aAAA;EACA,cAAA;AAvLJ;AA0LE;EACE,uBAAA;EACA,kBAAA;AAxLJ;AA2LE;EACE,kBAAA;AAzLJ;AA4LE;EACE,gBAAA;AA1LJ;AA6LE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AA3LJ;AA8LE;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,kCAAA;AA5LJ;AA+LE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AA7LJ;AAgME;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;AA9LJ;AAiME;EACE,WAAA;EACA,yBAAA;AA/LJ;AAkME;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhMJ;AAmME;EACE,kBAAA;EACA,oBAAA;AAjMJ;AAoME;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uFAAA;AAlMJ;AAqME;EACE,qBAhuC0B;EAiuC1B,8CAAA;AAnMJ;AAsME;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AApMJ;AAuME;EAEE,SAAA;EACA,gBAAA;AAtMJ;AAyME;EACE,qBAAA;AAvMJ;AA0ME;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAlwC0B;EAmwC1B,cAAA;EACA,eAAA;EACA,2BAAA;EACA,iFAAA;AAxMJ;AA2ME;EACE,mBAAA;AAzMJ;AA4ME;EACE,uCAAA;AA1MJ;AA6ME;EACE,mBAAA;EACA,aAAA;AA3MJ;AA8ME;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;AA5MJ;AA+ME;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AA9MJ;AAiNE;EACE,cAAA;AA/MJ;AAkNE;EAKE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;AApNJ;AAuNE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArNJ;AAwNE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAtNJ;AAyNE;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAp2C0B;EAq2C1B,eAAA;EACA,gBAAA;EACA,eAAA;AAvNJ;AA0NE;EACE,mBA32C0B;EA42C1B,cAAA;AAxNJ;AA2NE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAzNJ;AA4NE;EACE,aAAA;EACA,iBAAA;AA1NJ;AA8NE;EAEE,iBAAA;AA7NJ;AAgOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AA9NJ;AAiOE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/NJ;AAkOE;EACE,cAp5C0B;AAorC9B;AAmOE;EACE,cAt5C2B;AAqrC/B;AAoOE;EACE,cA35C4B;AAyrChC;AAqOE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;AAnOJ;AAsOE;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AArOJ;AAwOE;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAvOJ;AA0OE;EAEE,yBA37C6B;AAktCjC;AA4OE;EAEE,cAAA;EACA,gBAAA;AA3OJ;AA8OE;EACE,yBAAA;AA5OJ;AA+OE;EACE,yBAAA;AA7OJ;AAgPE;EACE,yBAAA;AA9OJ;AAiPE;EACE,oCAAA;AA/OJ;AAkPE;EACE,uBAAA;EACA,SAAA;AAhPJ;AAmPE;EACE,gBAAA;AAjPJ;AAoPE;EACE,eAAA;EACA,gBAAA;AAlPJ;AAqPE;EACE,yBAn+C6B;EAo+C7B,gBAAA;AAnPJ;AAsPE;EACE,cAAA;EACA,gBAAA;AApPJ;AAuPE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AArPJ;AAwPE;EACE,eAAA;EACA,SAAA;AAtPJ;AAyPE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBA5/C6B;EA6/C7B,eAAA;EACA,gBAAA;AAvPJ;AA0PE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AAxPJ;AA2PE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAzPJ;AA4PE;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AA1PJ;AA6PE;EACE,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AA3PJ;AA8PE;EACE,gBAAA;EACA,eAAA;AA5PJ;AA+PE;EACE,gBAAA;EACA,eAAA;AA7PJ;AAgQE;EACE,gBAAA;EACA,eAAA;AA9PJ;AAiQE;EACE,gBAAA;EACA,eAAA;AA/PJ;AAkQE;EACE,kBAAA;EACA,gBAAA;AAhQJ;AAmQE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAjQJ;AAoQE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAlQJ;AAqQE;EAEE,WAAA;EACA,eAAA;EACA,cAAA;AApQJ;AAuQE;EACE,WAAA;EACA,eAAA;AArQJ;AAwQE;EACE,WAAA;EACA,eAAA;AAtQJ;AAyQE;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AAxQJ;AA0QI;EACE,qBAAA;EACA,8CAAA;AAxQN;AA4QE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA1QJ;AA6QE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3QJ;AA8QE;EACE,qBAAA;EACA,4CAAA;AA5QJ;AA+QE;EACE,qBAAA;EACA,+CAAA;AA7QJ;AAgRE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA9QJ;AAiRE;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AA/QJ;AAkRE;EACE,qCAAA;EACA,gBAAA;AAhRJ;AAmRE;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,qBAAA;AAjRJ;AAoRE;EACE,UAAA;AAlRJ;AAqRE;EACE,uBAAA;AAnRJ;AAsRE;EACE,oBAAA;EACA,mBAAA;AApRJ;AAuRE;EACE,qCAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;AArRJ;AAwRE;EACE,QAAA;EACA,SAAA;AAtRJ;AAyRE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;AAvRJ;AA0RE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oCAAA;AAxRJ;AA2RE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;AAzRJ;AA4RE;EACE,mBAAA;AA1RJ;AA6RE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA3RJ;AA8RE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA5RJ;AA+RE;EACE,gBAAA;AA7RJ;AAiSE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AA/RJ;AAkSE;EACE,eAAA;AAhSJ;AAmSE;EACE,mCAAA;AAjSJ;AAmSI;;EAEE,2BAAA;AAjSN;AAoSI;EACE,sCAAA;EACA,WAAA;AAlSN;AAsSE;EACE,eAAA;AApSJ;AAuSE;EAEE,mBAAA;AAtSJ;AAySE;EACE,0BAAA;EACA,oBAAA;AAvSJ;AA0SE;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;AAxSJ;AA2SE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;EACA,oBAAA;AAzSJ;AA4SE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,+CAAA;EACA,oBAAA;AA1SJ;AA6SE;EACE,8CAAA;AA3SJ;AA8SE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AA5SJ;AA+SE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA7SJ;AAgTE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9SJ;AAiTE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA/SJ;AAkTE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAhTJ;AAmTE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAjTJ;AAoTE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlTJ;AAoTI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAlTN;AAqTI;EAEE,mBAAA;EACA,qBAAA;AApTN;AAwTE;EACE,iBAAA;EACA,gBAAA;AAtTJ;AAyTE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAvTJ;AA0TE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAxTJ;AA0TI;EACE,SAAA;AAxTN;AA4TE;EACE,aAAA;EACA,SAAA;AA1TJ;AA6TE;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;AA3TJ;AA8TE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA5TJ;AA+TE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA7TJ;AAgUE;EACE,YAAA;AA9TJ;AAiUE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA/TJ;AAkUE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAhUJ;AAmUE;EACE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AAjUJ;AAoUE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAlUJ;AAqUE;EACE,aAAA;EACA,SAAA;EACA,SAAA;AAnUJ;AAsUE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,qBAAA;AApUJ;AAuUE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArUJ;AAwUE;EACE,YAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAtUJ;AAyUE;EACE,gBAAA;EACA,6BAAA;AAvUJ;AAyUI;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;AAvUN;AA0UI;EACE,cAviEwB;EAwiExB,gBAAA;AAxUN;AA4UE;EACE,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,mBAAA;AA1UJ;AA4UI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA1UN;AA6UI;EACE,gBAAA;AA3UN;AA+UE;EACE,aAAA;AA7UJ;AAgVE;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AA9UJ;AAiVE;EACE,mBAAA;EACA,cAAA;AA/UJ;AAkVE;EACE,mBAAA;EACA,cAAA;AAhVJ;AAmVE;EACE,gDAAA;EACA,gBAAA;EACA,aAAA;AAjVJ;AAmVI;EACE,cAAA;AAjVN;AAoVI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AAlVN;AAqVI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAnVN;AAuVE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArVJ;AAwVE;EAEE,cAAA;AAvVJ;AA0VE;EACE,WAAA;EACA,sBAAA;AAxVJ;AA0VI;EACE,gBAAA;AAxVN;AA2VI;EACE,uBAAA;EACA,oBAAA;EACA,yBAAA;AAzVN;AA4VI;EACE,kBAAA;EACA,iBAAA;AA1VN;AA6VI;;EAEE,WAAA;AA3VN;AA8VI;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;AA5VN;AA+VI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA7VN;AAgWI;EACE,mBAAA;AA9VN;AAiWI;EACE,cAAA;EACA,gBAAA;AA/VN;AAmWE;EACE,iBAAA;EACA,YAAA;AAjWJ;AAoWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAlWJ;AAqWE;EACE,gBAAA;AAnWJ;AAsWE;EACE,oBAAA;AApWJ;AAuWE;EACE,oBAAA;AArWJ;AAwWE;EACE,oBAAA;EACA,gBAAA;AAtWJ;AAyWE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAvWJ;AA0WE;EACE,kBAAA;AAxWJ;AA2WE;EACE,SAAA;AAzWJ;AA4WE;EACE,cAAA;EACA,2BAAA;EACA,QAAA;EACA,iBAAA;AA1WJ;AA6WE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;AA3WJ;AA8WE;EACE,eAAA;EACA,iBAAA;AA5WJ;AA+WE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA7WJ;AAgXE;EACE,YAAA;EACA,eAAA;EACA,eAAA;AA9WJ;AAiXE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA/WJ;AAkXE;EACE,YAAA;EACA,eAAA;EACA,eAAA;AAhXJ;AAmXE;EACE,oBAAA;AAjXJ;AAoXE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAlXJ;AAqXE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;AAnXJ;AAsXE;EACE,uBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;AApXJ;AAuXE;EAGE,iBAAA;AAvXJ;AA0XE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAxXJ;AA2XE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAzXJ;AA4XE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AA1XJ;AA6XE;EACE,kBAAA;EACA,cAAA;AA3XJ;AA8XE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uFAAA;AA5XJ;AA8XI;EACE,qBAAA;EACA,4CAAA;AA5XN;AA+XI;EACE,mBAAA;EACA,aAAA;AA7XN;AAgYI;EACE,UAAA;AA9XN;AAkYE;EACE,cAAA;AAhYJ;AAmYE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AAjYJ;AAoYE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AAlYJ;AAoYI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAlYN;AAoYM;EACE,mBAAA;AAlYR;AAuYE;EACE,cAAA;EACA,2BAAA;EACA,gBAAA;AArYJ;AAwYE;EAEE,uBAAA;EACA,2BAAA;EACA,cAAA;AAvYJ;AA0YE;EAGE,iBAAA;EAEA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;AA3YJ;AA8YE;EACE,kBAAA;AA5YJ;AA+YE;EACE,SAAA;AA7YJ;AAgZE;EAGE,cAAA;EACA,YAAA;AAhZJ;AAmZE;EAEE,YAAA;EACA,2BAAA;AAlZJ;AAqZE;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AApZJ;AAuZE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AArZJ;AAwZE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAtZJ;AAyZE;EACE,gBAAA;AAvZJ;AA0ZE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxZJ;AA2ZE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AAzZJ;AA4ZE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AA1ZJ;AA6ZE;EACE,cAAA;AA3ZJ;AA8ZE;EACE,yBAAA;AA5ZJ;AA+ZE;EACE,yBAAA;AA7ZJ;AAgaE;EACE,cAAA;AA9ZJ;AAiaE;EACE,cAAA;AA/ZJ;AAkaE;EAEE,kBAAA;EACA,mBAAA;AAjaJ;AAoaE;EAEE,kBAAA;EACA,mBAAA;AAnaJ;AAsaE;EACE,yBAAA;AApaJ;AAuaE;EAEE,eAAA;AAtaJ;AAyaE;EAEE,gBAAA;AAxaJ;AA2aE;EACE,gBAAA;AAzaJ;AA4aE;EAEE,WAAA;AA3aJ;AA8aE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AA5aJ;AA+aE;EACE,iBAAA;EACA,SAAA;EACA,uBAAA;AA7aJ;AAgbE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA9aJ;AAibE;EACE,WAAA;EACA,YAAA;AA/aJ;AAkbE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAhbJ;AAmbE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjbJ;AAobE;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlbJ;AAqbE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;AAnbJ;AAsbE;EAEE,cAAA;AArbJ;AAwbE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAtbJ;AAybE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxbJ;AA2bE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAzbJ;AA4bE;EACE,eAAA;EACA,iBAAA;EACA,mBA7qF0B;EA8qF1B,cAAA;AA1bJ;AA6bE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AA3bJ;AA8bE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5bJ;AA+bE;EAEE,mBAAA;AA9bJ;AAicE;EACE,mBAAA;AA/bJ;AAkcE;EACE,mBAAA;AAhcJ;AAmcE;EACE,mBAAA;AAjcJ;AAocE;EACE,mBAAA;AAlcJ;AAqcE;EACE,mBAAA;AAncJ;AAscE;EACE,mBAAA;AApcJ;AAucE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AArcJ;AAucI;EAEE,UAAA;EACA,mBAAA;EACA,+BAAA;AAtcN;AA0cE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,UAAA;EACA,kBAAA;EACA,+BAAA;EACA,2EAAA;AAxcJ;AA0cI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;AAxcN;AA4cE;EAKE,mBAAA;EACA,WAAA;AA9cJ;AAidE;EAME,mBAAA;EACA,WAAA;AApdJ;AAudE;EAIE,mBAAA;EACA,WAAA;AAxdJ;AA2dE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAzdJ;AA4dE;EACE,yBAz0F6B;EA00F7B,eAAA;AA1dJ;AA6dE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA3dJ;AA8dE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,6EAAA;AA5dJ;AA+dE;EACE,qCAn2F0B;AAs4E9B;AAgeE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AA9dJ;AAieE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/dJ;AAkeE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAheJ;AAmeE;EACE,YAAA;EACA,oBAAA;EACA,qCA/3F0B;EAg4F1B,gBAAA;AAjeJ;AAoeE;EACE,YAAA;EACA,oBAAA;EACA,mBAr4F0B;AAm6E9B;AAqeE;EACE;IACE,0BAAA;EAneJ;EAseE;IACE,gDAAA;EApeJ;EAueE;IACE,iCAAA;EAreJ;EAueI;IAEE,WAAA;EAteN;EA0eE;IACE,qCAAA;EAxeJ;EA2eE;IAEE,0BAAA;EA1eJ;EA6eE;IACE,0BAAA;IACA,sBAAA;EA3eJ;EA8eE;IACE,mBAAA;IACA,eAAA;EA5eJ;AACF;AA+eE;EAx6FF;IAy6FI,WAAA;EA5eF;EA8eE;IACE,YAAA;IACA,QAAA;EA5eJ;EA+eE;IACE,WAAA;IACA,gBAAA;IACA,kBAAA;EA7eJ;EAgfE;IAGE,aAAA;IACA,mBAAA;EAhfJ;EAmfE;IACE,eAAA;EAjfJ;EAofE;IACE,sBAAA;IACA,oBAAA;EAlfJ;EAqfE;IACE,WAAA;IACA,cAAA;EAnfJ;EAsfE;IACE,WAAA;EApfJ;EAufE;IACE,WAAA;EArfJ;EAwfE;IACE,0BAAA;EAtfJ;EAyfE;IACE,SAAA;EAvfJ;EA0fE;IACE,iBAAA;IACA,aAAA;EAxfJ;EA2fE;IACE,eAAA;EAzfJ;EA4fE;IACE,eAAA;EA1fJ;EA6fE;IACE,sBAAA;IACA,uBAAA;EA3fJ;EA8fE;IACE,sBAAA;IACA,oBAAA;IACA,eAAA;EA5fJ;EA+fE;IACE,eAAA;IACA,wBAAA;EA7fJ;EAggBE;IACE,sBAAA;IACA,oBAAA;EA9fJ;EAigBE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,wBAAA;EA/fJ;EAkgBE;IACE,WAAA;IACA,8BAAA;EAhgBJ;EAmgBE;IACE,QAAA;IACA,+BAAA;EAjgBJ;EAogBE;IAME,WAAA;IACA,eAAA;IACA,cAAA;EAvgBJ;EA0gBE;IACE,eAAA;IACA,oBAAA;EAxgBJ;EA2gBE;IACE,WAAA;IACA,eAAA;IACA,wBAAA;EAzgBJ;EA4gBE;IAGE,WAAA;IACA,eAAA;IACA,cAAA;EA5gBJ;AACF;AA+gBE;EACE;IACE,iBAAA;IACA,uBAAA;IACA,8BAAA;EA7gBJ;EAghBE;IACE,yBAAA;IACA,cAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA9gBJ;AACF;AAihBE;EACE;IACE,iBAAA;IACA,uBAAA;EA/gBJ;EAkhBE;IACE,WAAA;IACA,iBAAA;IACA,yBAAA;EAhhBJ;EAmhBE;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;EAjhBJ;EAohBE;IAEE,WAAA;IACA,YAAA;IACA,eAAA;IACA,cAAA;EAnhBJ;AACF;AAshBE;EACE;IACE,yBAAA;EAphBJ;AACF;AAuhBE;EACE;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,8BAAA;EArhBJ;EAwhBE;IACE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;EAthBJ;AACF;;AA0hBA,2EAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAvhBF;;AA0hBA;EACE,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAvhBF;;AA0hBA;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAvhBF;;AA0hBA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAvhBF;;AA0hBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AAvhBF;;AA0hBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAvhBF;;AA0hBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAvhBF;;AA0hBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,4EAAA;AAvhBF;AAyhBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAvhBJ;AA0hBE;EACE,cAAA;EACA,mBAAA;EACA,YAAA;AAxhBJ;;AA6hBA;EACE,oBAAA;EACE,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AA1hBJ;;AA4hBA;EACE,4BAAA;AAzhBF","sourcesContent":["@import \"../../../styles/variables\";\n\n$sales-product-muted-foreground: hsl(220 10% 46%);\n$sales-product-muted-border: hsla(220, 10%, 46%, 0.18);\n$sales-product-muted-surface: hsla(220, 10%, 46%, 0.08);\n$sales-product-chart-primary: #2b74e4;\n$sales-product-chart-secondary: #94d0b5;\n$sales-product-chart-tertiary: #f6c15f;\n$sales-product-chart-warning: #8d4fd3;\n$sales-product-chart-extended: #5d97ee;\n\n.sales-product-analytics-dashboard {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 0 16px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: visible;\n  color: #17325c;\n  font-family: \"opensans\", sans-serif;\n\n  &__tabs {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px;\n    margin-bottom: 18px;\n    border-radius: 18px;\n    background: $sales-product-muted-surface;\n    width: fit-content;\n    max-width: 100%;\n    flex-shrink: 0;\n  }\n\n  &__tab {\n    border: 0;\n    border-radius: 14px;\n    background: transparent;\n    color: $sales-product-muted-foreground;\n    padding: 14px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.15;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.72);\n      color: #17325c;\n    }\n  }\n\n  &__tab--active {\n    background: #ffffff;\n    color: #17325c;\n    box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    width: 100%;\n    min-width: 0;\n    align-self: stretch;\n  }\n\n  &__section>.dashboard-section-header {\n    width: 100%;\n    box-sizing: border-box;\n    align-self: stretch;\n  }\n\n  &__section--inventory {\n    gap: 12px;\n  }\n\n  &__section .ant-spin-nested-loading,\n  &__section .ant-spin-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    align-self: stretch;\n    box-sizing: border-box;\n  }\n\n  &__overview-spin.ant-spin-nested-loading {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex-shrink: 0;\n    box-sizing: border-box;\n  }\n\n  &__overview-spin.ant-spin-nested-loading .ant-spin-container {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  &__inventory-spin.ant-spin-nested-loading {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex-shrink: 0;\n    box-sizing: border-box;\n  }\n\n  &__inventory-spin.ant-spin-nested-loading .ant-spin-container {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    align-items: stretch;\n    gap: 16px;\n  }\n\n  /* KPI row is first child of Spin container — force full width so cards can flex */\n  &__inventory-spin.ant-spin-nested-loading .ant-spin-container> :first-child {\n    width: 100%;\n    min-width: 0;\n    align-self: stretch;\n  }\n\n  &__card,\n  &__metric-card,\n  &__table-card {\n    background: #ffffff;\n    border: 1px solid $sales-product-muted-border;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);\n    height: 100%;\n  }\n\n  &__card {\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__card--sales-by-channel {\n    min-width: 0;\n    padding: 24px;\n  }\n\n  &__table-card {\n    padding: 0;\n  }\n\n  &__overview-title {\n    margin: 0;\n    color: #101828;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__overview-subtitle {\n    margin: 6px 0 0;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    line-height: 1.7;\n  }\n\n  &__overview-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n    position: sticky;\n    top: 0;\n    z-index: 8;\n    padding: 8px 0 14px;\n    background: #ffffff;\n    border-bottom: 1px solid rgba(23, 50, 92, 0.08);\n  }\n\n  &__date-range {\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  &__card,\n  &__table-card {\n    padding: 24px;\n  }\n\n  &__metrics {\n    display: grid;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n\n    /* Three KPIs: flex splits row evenly (inline style also sets display flex on this node). */\n    &--inventory {\n      >.dashboard-kpi-card {\n        flex: 1 1 0;\n        min-width: 0;\n        max-width: none;\n        box-sizing: border-box;\n      }\n    }\n  }\n\n  &__metrics--inventory {\n    gap: 22px !important;\n  }\n\n  &__metrics--inventory > .dashboard-kpi-card {\n    min-height: 122px;\n    padding: 22px 22px;\n    border-color: #e6edf7;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__title-row {\n    margin-bottom: 4px;\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__title {\n    color: #6b7280;\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__value {\n    color: #111827;\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 1.1;\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__description {\n    margin-top: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 7px;\n    background: #edf5ff;\n    color: $sales-product-chart-primary;\n  }\n\n  &__metrics--inventory .dashboard-kpi-card__icon svg {\n    width: 21px;\n    height: 21px;\n  }\n\n  &__metrics--five {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  &__metrics--sales {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2.15fr) !important;\n    margin-bottom: 18px;\n  }\n\n  @media (max-width: 1200px) {\n    &__metrics--sales {\n      grid-template-columns: 1fr !important;\n    }\n  }\n\n  &__metrics--sales > .dashboard-kpi-card {\n    min-height: 96px;\n    padding: 16px 24px;\n    gap: 8px;\n  }\n\n  &__metrics--sales .dashboard-kpi-card__header {\n    align-items: flex-start;\n  }\n\n  &__metrics--sales .dashboard-kpi-card__title-row {\n    margin-bottom: 10px;\n  }\n\n  &__metrics--sales .dashboard-kpi-card__value {\n    font-size: 22px;\n    line-height: 1.15;\n        margin-top: 20px;\n  }\n\n  &__metrics--sales .dashboard-kpi-card__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n  }\n\n  &__metrics--sales .dashboard-kpi-card__footer {\n    margin-top: -2px;\n  }\n\n  &__status-kpi-card.dashboard-kpi-card {\n    min-width: 0;\n    position: relative;\n    overflow: visible;\n  }\n\n  &__top-channel-kpi-card.dashboard-kpi-card {\n    position: relative;\n    overflow: visible;\n  }\n\n  &__top-channel-value {\n    position: relative;\n    display: inline-flex;\n    max-width: 100%;\n    outline: none;\n  }\n\n  &__top-channel-value:focus-visible {\n    border-radius: 4px;\n    box-shadow: 0 0 0 3px rgba(43, 104, 173, 0.16);\n  }\n\n  &__top-channel-tooltip {\n    position: absolute;\n    z-index: 5;\n    left: 50%;\n    top: calc(100% + 14px);\n    transform: translateX(-50%);\n    display: grid;\n    gap: 10px;\n    width: 210px;\n    padding: 12px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n    color: #101828;\n    pointer-events: none;\n  }\n\n  &__top-channel-tooltip::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: -6px;\n    transform: translateX(-50%) rotate(45deg);\n    width: 12px;\n    height: 12px;\n    background: #ffffff;\n    border-left: 1px solid #e2e8f0;\n    border-top: 1px solid #e2e8f0;\n  }\n\n  &__top-channel-tooltip-row {\n    display: grid;\n    grid-template-columns: 10px minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    color: #475467;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__top-channel-tooltip-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 999px;\n    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\n  }\n\n  &__top-channel-tooltip-label {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n  }\n\n  &__top-channel-tooltip strong {\n    color: #1f2937;\n    font-size: 16px;\n    font-weight: 800;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__status-kpi-card .dashboard-kpi-card__value {\n    font-size: 14px;\n  }\n\n  &__status-kpi {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  &__status-kpi-bar {\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 12px;\n    overflow: visible;\n    border-radius: 4px;\n    background: #eef2f7;\n  }\n\n  &__status-kpi-segment {\n    display: block;\n    min-width: 0;\n    height: 12px;\n    cursor: pointer;\n    transition: filter 0.16s ease, transform 0.16s ease;\n  }\n\n  &__status-kpi-segment:first-child {\n    border-radius: 4px 0 0 4px;\n  }\n\n  &__status-kpi-segment:last-of-type {\n    border-radius: 0 4px 4px 0;\n  }\n\n  &__status-kpi-segment:hover,\n  &__status-kpi-segment:focus-visible {\n    filter: brightness(0.95) saturate(1.12);\n    outline: none;\n  }\n\n  &__status-kpi-tooltip {\n    z-index: 2000;\n    max-width: calc(100vw - 32px);\n    padding: 16px 18px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n    color: #101828;\n    pointer-events: none;\n  }\n\n  &__status-kpi-tooltip::after {\n    content: \"\";\n    position: absolute;\n    left: var(--status-tooltip-arrow-left, 50%);\n    top: -6px;\n    transform: translateX(-50%) rotate(45deg);\n    width: 12px;\n    height: 12px;\n    background: #ffffff;\n    border-left: 1px solid #e2e8f0;\n    border-top: 1px solid #e2e8f0;\n  }\n\n  &__status-kpi-tooltip-label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 8px;\n    color: #94a3b8;\n    font-size: 10px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  &__status-kpi-tooltip-description {\n    display: block;\n    margin-bottom: 16px;\n    color: #7a8aa0;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.5;\n    white-space: normal;\n  }\n\n  &__status-kpi-tooltip strong {\n    display: block;\n    color: #1f2937;\n    font-size: 26px;\n    line-height: 1;\n    font-weight: 800;\n  }\n\n  &__status-kpi-legend {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px 14px;\n    color: #64748b;\n    font-size: 11px;\n    font-weight: 600;\n  }\n\n  &__status-kpi-legend span {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  &__status-kpi-legend i {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n  }\n\n  &__sales-channel-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 0;\n  }\n\n  &__sales-channel-head .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__channel-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n    color: #64748b;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    user-select: none;\n    margin-top: 4px;\n  }\n\n  &__channel-toggle input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &__channel-toggle i {\n    position: relative;\n    width: 42px;\n    height: 24px;\n    border-radius: 999px;\n    background: #c4c7cc;\n    transition: background 0.2s ease;\n  }\n\n  &__channel-toggle i::after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18);\n    transition: transform 0.2s ease;\n  }\n\n  &__channel-toggle input:checked+i {\n    background: #1f4e7d;\n  }\n\n  &__channel-toggle input:checked+i::after {\n    transform: translateX(18px);\n  }\n\n  /* Three KPIs: equal columns across full row. Compound selector beats OmnichannelAnalyticsTabsDashboard.scss,\n     which reuses this block name and would otherwise override --three with repeat(4). */\n  &__metrics#{&}__metrics--three {\n    display: grid;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n    justify-items: stretch;\n  }\n\n  &__metrics#{&}__metrics--three > .dashboard-kpi-card {\n    min-width: 0;\n    width: 100%;\n    max-width: none;\n    box-sizing: border-box;\n  }\n\n  &__metrics--customers {\n    gap: 22px;\n    margin-bottom: 18px;\n  }\n\n  &__metrics--customers > .dashboard-kpi-card {\n    min-height: 126px;\n    padding: 24px 24px 22px;\n    border-color: #dfe7f2;\n    border-radius: 8px;\n    box-shadow:\n      0 1px 2px rgba(16, 24, 40, 0.04),\n      0 1px 4px rgba(16, 24, 40, 0.08);\n    gap: 8px;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__header {\n    gap: 16px;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__title-row {\n    margin-bottom: 3px;\n    gap: 4px;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__title {\n    color: #667085;\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    line-height: 1.25;\n  }\n\n  &__metrics--customers .definition-tooltip__trigger {\n    width: 13px;\n    height: 13px;\n    min-width: 13px;\n    font-size: 8px;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__value {\n    color: #0f172a;\n    font-size: 30px;\n    font-weight: 800;\n    line-height: 1.05;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 7px;\n    background: #eef5ff;\n    color: $sales-product-chart-primary;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__icon svg {\n    width: 22px;\n    height: 22px;\n    stroke-width: 2.6;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__period {\n    margin-top: 2px;\n    gap: 3px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__change {\n    gap: 2px;\n    font-size: 11px;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__change svg {\n    width: 12px;\n    height: 12px;\n    stroke-width: 3;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__change--positive {\n    color: #12a855;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__change--negative {\n    color: #e54848;\n  }\n\n  &__metrics--customers .dashboard-kpi-card__comparison {\n    color: #98a2b3;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  /* Must stay 5 tracks (matches hidden inventory KPI); TS also sets gridTemplateColumns for reliability */\n  &__metrics--overview {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    justify-items: stretch;\n    align-items: stretch;\n    align-self: stretch;\n  }\n\n  &__metrics--overview>.dashboard-kpi-card {\n    min-width: 0;\n    width: 100%;\n    max-width: none;\n    box-sizing: border-box;\n  }\n\n  // Five cards per row leaves little width per title — the shared card's default\n  // 2-line clamp wrapped labels like \"Customers Ordered\" under the help icon and\n  // cart icon instead of alongside them. Force a single line with ellipsis here\n  // rather than in the shared component, since other dashboards rely on the\n  // 2-line wrap for longer titles.\n  &__metrics--overview .dashboard-kpi-card__title {\n    display: block;\n    max-height: none;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  &__metric-card {\n    padding: 14px 20px;\n  }\n\n  &__metric-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__metric-label {\n    margin: 0;\n    color: $sales-product-muted-foreground;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  &__metric-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 10px;\n    background: $sales-product-muted-surface;\n    color: $sales-product-chart-primary;\n    flex-shrink: 0;\n  }\n\n  &__metric-icon-svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  &__metric-value {\n    font-family: 'opensans', sans-serif;\n    color: #000000;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__metric-copy {\n    margin: 8px 0 0;\n    color: $sales-product-muted-foreground;\n    font-size: 13px;\n    line-height: 1.6;\n    font-weight: 500;\n  }\n\n  &__metric-copy--positive {\n    color: #198754;\n  }\n\n  &__metric-copy--negative {\n    color: #c33243;\n  }\n\n  &__metric-copy-trend {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 18px;\n    align-items: stretch;\n  }\n\n  &__grid--overview-charts {\n    align-items: stretch;\n  }\n\n  &__grid--top-products {\n    align-items: start;\n  }\n\n  &__card--overview-chart {\n    min-height: 0;\n  }\n\n  &__overview-chart-head {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 44px;\n    margin-bottom: 14px;\n\n    .sales-product-analytics-dashboard__title-with-tooltip {\n      margin-bottom: 0;\n    }\n  }\n\n  &__chart-wrap--overview {\n    flex: 1 1 auto;\n    width: 100%;\n    height: 300px;\n    min-height: 300px;\n  }\n\n  /**\n   * Recharts positions every tick/label with absolute SVG coordinates and `text-anchor`,\n   * assuming an LTR flow. Inheriting `dir=\"rtl\"` from <html> flips that anchoring and\n   * clips axis labels off the edge, so the SVG stays LTR and axis/label sides are\n   * mirrored through props instead (see `rtlChartProps`).\n   * Scoped to the surface only — `.recharts-tooltip-wrapper` is a sibling div that must\n   * keep the page direction so its Arabic text and punctuation read correctly.\n   */\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  &__chart-wrap--overview-pie {\n    min-width: 0;\n    justify-self: stretch;\n    width: 100%;\n  }\n\n  &__overview-channel-body {\n    display: block;\n    flex: 1 1 auto;\n    min-height: 0;\n    min-width: 0;\n    width: 100%;\n  }\n\n  &__chart-wrap--overview-channel-bars {\n    position: relative;\n    width: 100%;\n    height: clamp(230px, 48px * var(--overview-channel-rows, 6), 550px);\n    min-height: 230px;\n\n    .recharts-wrapper,\n    .recharts-surface {\n      width: 100% !important;\n    }\n  }\n\n  &__channel-bar-label {\n    fill: #0f172a;\n    font-size: 12px;\n    font-weight: 800;\n    font-family: \"opensans\", sans-serif;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__channel-bar-label-percent {\n    fill: #0f172a;\n    font-size: 12px;\n    font-weight: 800;\n  }\n\n  &__bar-label {\n    fill: #0f172a;\n    font-size: 11px;\n    font-weight: 700;\n    font-family: \"opensans\", sans-serif;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__channel-tooltip {\n    min-width: 220px;\n  }\n\n  &__channel-tooltip--compact {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n    max-width: 280px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    box-shadow:\n      0 4px 6px -1px rgba(15, 23, 42, 0.08),\n      0 10px 20px -4px rgba(15, 23, 42, 0.12);\n\n    &:has(.sales-product-analytics-dashboard__channel-tooltip-others-list--columns) {\n      max-width: 560px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: -6px;\n      left: var(--channel-tooltip-caret-left, 50%);\n      transform: translateX(-50%);\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-bottom: 7px solid #ffffff;\n      filter: drop-shadow(0 -1px 0 #e2e8f0);\n    }\n  }\n\n  &__channel-tooltip-floating {\n    position: absolute;\n    z-index: 25;\n    pointer-events: none;\n    transform: translateY(0);\n  }\n\n  &__channel-tooltip-single-row,\n  &__channel-tooltip-single-sales {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 12px minmax(52px, auto);\n    align-items: center;\n    column-gap: 8px;\n    font-size: 12px;\n    line-height: 1.3;\n  }\n\n  &__channel-tooltip-single-sales {\n    grid-template-columns: minmax(0, 1fr) auto;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid #edf2f7;\n    color: #64748b;\n\n    strong {\n      color: #17325c;\n      font-weight: 700;\n      font-variant-numeric: tabular-nums;\n    }\n  }\n\n  &__channel-tooltip-others-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__channel-tooltip-others-list--columns {\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-rows: repeat(var(--others-tooltip-rows, 1), auto);\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 28px;\n    row-gap: 8px;\n  }\n\n  &__channel-tooltip-others-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 12px minmax(52px, auto);\n    align-items: center;\n    column-gap: 8px;\n    font-size: 12px;\n    line-height: 1.3;\n    width: 100%;\n  }\n\n  &__channel-tooltip-others-list--columns &__channel-tooltip-others-row {\n    min-width: 0;\n    grid-template-columns: minmax(0, 1fr) 12px minmax(44px, auto);\n  }\n\n  &__channel-tooltip-others-swatch {\n    width: 9px;\n    height: 9px;\n    border-radius: 1px;\n    flex-shrink: 0;\n    justify-self: center;\n  }\n\n  &__channel-tooltip-others-name {\n    color: #64748b;\n    font-weight: 500;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__channel-tooltip-others-pct {\n    color: #475569;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    text-align: left;\n  }\n\n  &__legend-list--overview-channel {\n    gap: 10px;\n    margin: 0;\n    align-self: center;\n    justify-self: end;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  &__legend-row--channel-swatch {\n    gap: 10px;\n  }\n\n  &__legend-row-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  &__legend-swatch {\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    flex-shrink: 0;\n    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);\n  }\n\n  &__legend-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 13px;\n  }\n\n  &__legend-percent {\n    flex-shrink: 0;\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__grid--three {\n    grid-template-columns: 1.15fr 0.85fr 0.85fr;\n    min-width: 0;\n  }\n\n  &__grid--three>* {\n    min-width: 0;\n  }\n\n  &__grid>*,\n  &__grid--three>* {\n    align-self: stretch;\n    height: 100%;\n  }\n\n  &__card--full-span {\n    grid-column: 1 / -1;\n  }\n\n  &__card--customer-segmentation {\n    padding-top: 19px;\n    padding-bottom: 19px;\n  }\n\n  &__card--customer-segmentation &__title-with-tooltip {\n    margin-bottom: 4px;\n  }\n\n  &__card--customer-segmentation .customer-segmentation-kpi {\n    margin-top: 0;\n  }\n\n  &__card-title {\n    margin: 0 0 14px;\n    color: #000000;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'opensans', sans-serif;\n  }\n\n  &__title-with-tooltip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 14px;\n  }\n\n  &__table-card .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__title-with-tooltip &__card-title {\n    margin-bottom: 0;\n    line-height: 1.25;\n  }\n\n  &__title-with-tooltip .definition-tooltip {\n    margin-top: 0;\n    flex-shrink: 0;\n    align-self: center;\n  }\n\n  &__card-subtitle {\n    margin: -6px 0 14px;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    line-height: 1.6;\n  }\n\n  &__chart-wrap {\n    width: 100%;\n    height: 280px;\n    min-height: 280px;\n    position: relative;\n    overflow: visible;\n  }\n\n  &__chart-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    color: #64748b;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  &__inventory-empty-state {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    color: #64748b;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.4;\n    text-align: center;\n  }\n\n  &__inventory-empty-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background: #eef4ff;\n    color: $sales-product-chart-primary;\n  }\n\n  &__inventory-empty-cell {\n    height: 190px;\n    padding: 18px 22px !important;\n    text-align: center !important;\n    vertical-align: middle !important;\n  }\n\n  &__inventory-empty-cell .sales-product-analytics-dashboard__inventory-empty-state {\n    display: flex;\n    margin: 0 auto;\n  }\n\n  &__inventory-chart-card {\n    padding: 28px 28px 26px;\n    border-radius: 8px;\n  }\n\n  &__inventory-chart-card .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 4px;\n  }\n\n  &__inventory-chart-card .sales-product-analytics-dashboard__card-subtitle {\n    margin: 0 0 18px;\n  }\n\n  &__inventory-chart-card .sales-product-analytics-dashboard__chart-wrap {\n    height: 340px;\n    min-height: 340px;\n    margin-left: 0;\n  }\n\n  &__threshold-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 40;\n    background: rgba(15, 23, 42, 0.35);\n  }\n\n  &__threshold-control {\n    position: relative;\n    z-index: 45;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__inventory-header .dashboard-section-header__actions {\n    margin-inline-start: auto;\n    width: auto;\n    justify-content: flex-end;\n  }\n\n  &__inventory-header &__threshold-control {\n    width: auto;\n    justify-content: flex-end;\n  }\n\n  &__threshold-control label {\n    margin: 0;\n    color: #344054;\n    font-size: 14px;\n    font-weight: 800;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &__threshold-input-wrap {\n    position: relative;\n    display: inline-flex;\n  }\n\n  &__threshold-input-wrap input {\n    width: 112px;\n    height: 42px;\n    padding: 0 38px 0 12px;\n    border: 1px solid #cfd8e5;\n    border-radius: 7px;\n    background: #ffffff;\n    color: #0f172a;\n    font-size: 14px;\n    font-weight: 500;\n    outline: none;\n    transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;\n  }\n\n  &__threshold-input-wrap input:focus {\n    border-color: $sales-product-chart-primary;\n    box-shadow: 0 0 0 3px rgba(43, 104, 173, 0.12);\n  }\n\n  &__threshold-input-wrap input:disabled {\n    background: #c7c7c7;\n    border-color: #c7c7c7;\n    color: #6f7480;\n    cursor: not-allowed;\n    opacity: 1;\n  }\n\n  &__threshold-input-wrap input::-webkit-outer-spin-button,\n  &__threshold-input-wrap input::-webkit-inner-spin-button {\n    margin: 0;\n    appearance: none;\n  }\n\n  &__threshold-input-wrap input[type=\"number\"] {\n    appearance: textfield;\n  }\n\n  &__threshold-commit-button {\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: 0;\n    border-radius: 6px;\n    background: $sales-product-chart-primary;\n    color: #ffffff;\n    cursor: pointer;\n    transform: translateY(-50%);\n    transition: background-color 0.16s ease, opacity 0.16s ease, transform 0.16s ease;\n  }\n\n  &__threshold-commit-button:hover:not(:disabled) {\n    background: #245a95;\n  }\n\n  &__threshold-commit-button:active:not(:disabled) {\n    transform: translateY(-50%) scale(0.96);\n  }\n\n  &__threshold-commit-button:disabled {\n    cursor: not-allowed;\n    opacity: 0.38;\n  }\n\n  &__threshold-disabled-tooltip {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 4px;\n    z-index: 50;\n    display: none;\n    width: 258px;\n    padding: 12px 14px;\n    border-radius: 7px;\n    background: #ffffff;\n    color: #667085;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1.35;\n    box-shadow: 0 18px 34px rgba(15, 23, 42, 0.16);\n  }\n\n  &__threshold-disabled-tooltip::before,\n  &__threshold-confirm::before {\n    content: \"\";\n    position: absolute;\n    top: -8px;\n    right: 28px;\n    width: 16px;\n    height: 16px;\n    background: #ffffff;\n    transform: rotate(45deg);\n  }\n\n  &__threshold-input-wrap--disabled:hover &__threshold-disabled-tooltip {\n    display: block;\n  }\n\n  &__threshold-confirm {\n    // Resets the browser's own <dialog> UA styles (a default black `border:\n    // solid`, content-box sizing, and a max-width/margin meant for the\n    // showModal() top-layer case) — this is rendered via the `open` attribute\n    // directly, not showModal(), so none of that default chrome applies here.\n    position: absolute;\n    top: calc(100% + 18px);\n    right: 14px;\n    z-index: 55;\n    box-sizing: border-box;\n    width: 402px;\n    max-width: none;\n    max-height: none;\n    margin: 0;\n    padding: 22px 18px 24px;\n    border: none;\n    border-radius: 7px;\n    background: #ffffff;\n    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.2);\n  }\n\n  &__threshold-confirm p {\n    position: relative;\n    z-index: 1;\n    margin: 0 0 18px;\n    color: #667085;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n  }\n\n  &__threshold-confirm div {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n\n  &__threshold-confirm button {\n    min-width: 60px;\n    height: 38px;\n    border: 1px solid $sales-product-chart-primary;\n    border-radius: 8px;\n    background: #ffffff;\n    color: $sales-product-chart-primary;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  &__threshold-confirm button:last-child {\n    background: $sales-product-chart-primary;\n    color: #ffffff;\n  }\n\n  &__inventory-y-axis-tick {\n    fill: #5f6b7a;\n    font-size: 14px;\n    font-weight: 500;\n    text-anchor: start;\n    dominant-baseline: middle;\n  }\n\n  &__chart-wrap--sm {\n    height: 220px;\n    min-height: 220px;\n  }\n\n  /* Recharts can paint slightly outside the box — avoid clipping in flex layouts */\n  &__chart-wrap .recharts-responsive-container,\n  &__chart-wrap--sm .recharts-responsive-container {\n    overflow: visible;\n  }\n\n  &__chart-legend {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n    margin-top: 10px;\n  }\n\n  &__chart-legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1;\n  }\n\n  &__chart-legend-item--revenue {\n    color: $sales-product-chart-primary;\n  }\n\n  &__chart-legend-item--expenses {\n    color: $sales-product-chart-tertiary;\n  }\n\n  &__chart-legend-item--profit {\n    color: $sales-product-chart-secondary;\n  }\n\n  &__chart-legend-swatch {\n    width: 10px;\n    height: 10px;\n    background: currentColor;\n    flex-shrink: 0;\n  }\n\n  &__summary-list,\n  &__legend-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__summary-row,\n  &__legend-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13px;\n  }\n\n  &__summary-row span:first-child,\n  &__legend-row span:first-child {\n    color: $sales-product-muted-foreground;\n  }\n\n  &__summary-row span:last-child,\n  &__legend-row span:last-child {\n    color: #173f76;\n    font-weight: 700;\n  }\n\n  &__summary-value--positive {\n    color: $sales-product-chart-secondary !important;\n  }\n\n  &__summary-value--negative {\n    color: $sales-product-chart-tertiary !important;\n  }\n\n  &__summary-value--warning {\n    color: $sales-product-chart-warning !important;\n  }\n\n  &__summary-value--muted {\n    color: $sales-product-muted-foreground !important;\n  }\n\n  &__legend-row--center {\n    justify-content: center;\n    gap: 24px;\n  }\n\n  &__legend-row--breakdown {\n    margin-top: -2px;\n  }\n\n  &__legend-label {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  &__legend-label--muted {\n    color: $sales-product-muted-foreground;\n    font-weight: 500;\n  }\n\n  &__legend-label--strong {\n    color: #173f76;\n    font-weight: 700;\n  }\n\n  &__legend-value--plain {\n    color: #173f76;\n    font-weight: 700;\n    min-width: 24px;\n    text-align: right;\n  }\n\n  &__legend-row--segmentation {\n    margin-top: 4px;\n    gap: 28px;\n  }\n\n  &__legend-dot-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  &__legend-dot {\n    width: 14px;\n    height: 14px;\n    border-radius: 999px;\n    flex-shrink: 0;\n  }\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  &__filters--inline {\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n    margin-bottom: 0;\n  }\n\n  &__filters--stacked {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    margin-bottom: 20px;\n  }\n\n  &__search {\n    min-width: 220px;\n    flex: 1 1 220px;\n  }\n\n  &__search--orders {\n    min-width: 230px;\n    flex: 0 0 230px;\n  }\n\n  &__search--inventory {\n    min-width: 260px;\n    flex: 0 0 260px;\n  }\n\n  &__search--customers {\n    min-width: 260px;\n    flex: 0 0 260px;\n  }\n\n  &__select-menu {\n    position: relative;\n    min-width: 180px;\n  }\n\n  &__select-menu--orders {\n    min-width: 240px;\n    width: 240px;\n    flex: 0 0 240px;\n  }\n\n  &__select-menu--inventory {\n    min-width: 220px;\n    width: 220px;\n    flex: 0 0 220px;\n  }\n\n  &__search--full,\n  &__select--full {\n    width: 100%;\n    min-width: 100%;\n    flex: 0 0 auto;\n  }\n\n  &__select--orders {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  &__select--inventory {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  &__search input,\n  &__select-trigger {\n    width: 100%;\n    height: 48px;\n    padding: 0 14px;\n    border: 1px solid $sales-product-muted-border;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #17325c;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &:focus {\n      border-color: #2c68ad;\n      box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.12);\n    }\n  }\n\n  &__select-trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 0 16px 0 18px;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  &__select-trigger span {\n    flex: 1 1 auto;\n    min-width: 0;\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__select-trigger:hover {\n    border-color: #cfd8e3;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  }\n\n  &__select-trigger--open {\n    border-color: #cfd8e3;\n    box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);\n  }\n\n  &__select-trigger-icon {\n    width: 16px;\n    height: 16px;\n    color: #6b7280;\n    flex-shrink: 0;\n  }\n\n  &__select-dropdown {\n    position: fixed;\n    z-index: 2000;\n    min-width: 160px;\n    max-height: 240px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 6px;\n    border: 1px solid #e6edf7;\n    border-radius: 12px;\n    background: #ffffff;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n  }\n\n  &__select-dropdown--inventory-categories {\n    max-height: min(180px, calc(100vh - 120px));\n    overflow: hidden;\n  }\n\n  &__select-dropdown-scroll {\n    min-height: 0;\n    flex: 1 1 auto;\n    overflow-y: auto;\n    scrollbar-color: #cbd5e1 transparent;\n    scrollbar-width: thin;\n  }\n\n  &__select-dropdown-scroll::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &__select-dropdown-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &__select-dropdown-scroll::-webkit-scrollbar-thumb {\n    border-radius: 999px;\n    background: #cbd5e1;\n  }\n\n  &__select-dropdown-scroll--inventory-categories {\n    max-height: min(180px, calc(100vh - 120px));\n    padding-right: 10px;\n    overscroll-behavior: contain;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  &__select-dropdown-scroll--inventory-categories::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n\n  &__select-dropdown-scrollbar {\n    position: absolute;\n    top: 8px;\n    right: 6px;\n    bottom: 8px;\n    width: 8px;\n    border-radius: 999px;\n    background: #f3f6fb;\n    pointer-events: none;\n  }\n\n  &__select-dropdown-scrollbar-thumb {\n    width: 100%;\n    min-height: 24px;\n    border-radius: 999px;\n    background: #cbd5e1;\n    transition: transform 0.12s ease-out;\n  }\n\n  &__select-option {\n    display: grid;\n    grid-template-columns: 20px minmax(0, 1fr);\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    min-height: 40px;\n    padding: 10px 12px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #0f172a;\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease;\n  }\n\n  &__select-option:hover {\n    background: #f2f2f2;\n  }\n\n  &__select-option--active {\n    background: #e4e4e4;\n    color: #1f1f1f;\n    font-weight: 600;\n  }\n\n  &__select-option-check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    color: #111827;\n  }\n\n  &__table-wrap {\n    overflow-x: auto;\n  }\n\n  /* Global `.dashboard-data-table-panel` uses overflow:hidden, which can clip the inner scroll+table in grid layouts. */\n  &__table-card.dashboard-data-table-panel {\n    width: 100%;\n    min-width: 0;\n    overflow: visible;\n    padding: 0;\n  }\n\n  &__table-card.dashboard-data-table-panel .dashboard-data-table-scroll {\n    max-width: 100%;\n  }\n\n  &__table.dashboard-data-table {\n    font-family: 'opensans', sans-serif;\n\n    th.dashboard-data-table__number,\n    td.dashboard-data-table__number {\n      text-align: left !important;\n    }\n\n    th.dashboard-data-table__number .dashboard-data-table__sort {\n      justify-content: flex-start !important;\n      width: auto;\n    }\n  }\n\n  &__order-row {\n    cursor: pointer;\n  }\n\n  &__order-row:hover td,\n  &__order-row:focus-visible td {\n    background: #f8fbff;\n  }\n\n  &__order-row:focus-visible {\n    outline: 2px solid #2b68ad;\n    outline-offset: -2px;\n  }\n\n  &__order-panel-shell {\n    position: fixed;\n    inset: 0;\n    z-index: 1400;\n    pointer-events: none;\n  }\n\n  &__order-panel-backdrop {\n    position: absolute;\n    inset: 0;\n    border: 0;\n    background: rgba(15, 23, 42, 0.48);\n    cursor: default;\n    pointer-events: auto;\n  }\n\n  &__order-panel {\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    display: flex;\n    flex-direction: column;\n    width: min(421px, 100vw);\n    height: 100%;\n    padding: 24px 20px 28px;\n    overflow-y: auto;\n    background: #ffffff;\n    border-radius: 0 0 0 0px;\n    box-shadow: -18px 0 36px rgba(15, 23, 42, 0.16);\n    pointer-events: auto;\n  }\n\n  [dir=\"rtl\"] &__order-panel {\n    box-shadow: 18px 0 36px rgba(15, 23, 42, 0.16);\n  }\n\n  &__order-panel-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    padding-bottom: 30px;\n    margin: 0 -20px 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: 1px solid #eef2f7;\n  }\n\n  &__order-panel-eyebrow {\n    margin: 0 0 5px;\n    color: #667085;\n    font-size: 11px;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  &__order-panel-header h3 {\n    margin: 0 0 4px;\n    color: #0f1f3d;\n    font-size: 20px;\n    line-height: 1.2;\n    font-weight: 900;\n  }\n\n  &__order-panel-header span {\n    color: #8b9ab1;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  &__order-panel-close {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #9aa6b8;\n    cursor: pointer;\n  }\n\n  &__order-panel-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin: 18px 0 4px;\n  }\n\n  &__order-panel-export {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 128px;\n    height: 38px;\n    min-height: 0;\n    padding: 0 14px;\n    border: 1px solid #d9e2ef;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #475569;\n    font-size: 12px;\n    font-weight: 800;\n    line-height: 1;\n    cursor: pointer;\n    box-shadow: none;\n\n    svg {\n      width: 12px;\n      height: 12px;\n      stroke-width: 2.5;\n      color: #64748b;\n    }\n\n    &:hover,\n    &:focus-visible {\n      background: #f8fbff;\n      border-color: #c7d7ee;\n    }\n  }\n\n  &__order-panel-section {\n    padding: 0 0 30px;\n    border-bottom: 0;\n  }\n\n  &__order-panel-section h4 {\n    margin: 0 0 20px;\n    color: #98a6bd;\n    font-size: 13px;\n    font-weight: 800;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n\n  &__order-panel-section-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 18px;\n\n    h4 {\n      margin: 0;\n    }\n  }\n\n  &__order-products {\n    display: grid;\n    gap: 14px;\n  }\n\n  &__order-product {\n    display: grid;\n    grid-template-columns: 60px minmax(0, 1fr) auto;\n    gap: 16px;\n    align-items: center;\n    min-height: 96px;\n    padding: 14px 16px;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    background: #ffffff;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03);\n  }\n\n  &__order-product-image {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 60px;\n    width: 60px;\n    overflow: hidden;\n    border-radius: 8px;\n    background: #f1f4f8;\n    color: #93a3b8;\n  }\n\n  &__order-product-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__order-product-main {\n    min-width: 0;\n  }\n\n  &__order-product-main strong {\n    display: block;\n    color: #111827;\n    font-size: 16px;\n    line-height: 1.35;\n    font-weight: 900;\n  }\n\n  &__order-product-main > span {\n    display: block;\n    margin-top: 3px;\n    color: #6b7280;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  &__order-product-price {\n    margin-top: 9px !important;\n    color: #111827 !important;\n    font-size: 14px !important;\n    font-weight: 800 !important;\n  }\n\n  &__order-product-qty {\n    align-self: end;\n    padding-bottom: 5px;\n    color: #7f93b4;\n    font-size: 10px;\n    font-weight: 900;\n    white-space: nowrap;\n  }\n\n  &__order-detail-list {\n    display: grid;\n    gap: 16px;\n    margin: 0;\n  }\n\n  &__order-detail-list div {\n    display: grid;\n    grid-template-columns: minmax(110px, 0.7fr) minmax(0, 1fr);\n    gap: 12px;\n    align-items: baseline;\n  }\n\n  &__order-detail-list dt {\n    color: #6b7a92;\n    font-size: 13px;\n    font-weight: 700;\n  }\n\n  &__order-detail-list dd {\n    min-width: 0;\n    margin: 0;\n    color: #111827;\n    font-size: 13px;\n    font-weight: 500;\n    overflow-wrap: anywhere;\n    text-align: right;\n  }\n\n  &__order-detail-list-total {\n    padding-top: 6px;\n    border-top: 1px solid #eef2f7;\n\n    dt,\n    dd {\n      color: #111827;\n      font-size: 15px;\n      font-weight: 900;\n    }\n\n    dd {\n      color: $sales-product-chart-primary;\n      font-weight: 900;\n    }\n  }\n\n  &__order-detail-list-status {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-start;\n    gap: 8px !important;\n\n    dt {\n      color: #64748b;\n      font-size: 11px;\n      font-weight: 900;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n    }\n\n    dd {\n      text-align: left;\n    }\n  }\n\n  &__order-detail-list-status + div {\n    display: none;\n  }\n\n  &__order-status-badge {\n    display: inline-flex;\n    align-items: center;\n    min-height: 16px;\n    padding: 3px 8px;\n    border-radius: 4px;\n    background: #eef2f7;\n    color: #475569;\n    font-size: 9px;\n    font-weight: 900;\n    text-transform: uppercase;\n  }\n\n  &__order-status-badge--paid {\n    background: #d9fbe8;\n    color: #179b54;\n  }\n\n  &__order-status-badge--pending {\n    background: #fff3d6;\n    color: #b45309;\n  }\n\n  &__order-detail-list--customer {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: 28px;\n    row-gap: 18px;\n\n    div {\n      display: block;\n    }\n\n    dt {\n      margin-bottom: 4px;\n      font-size: 11px;\n      color: #98a6bd;\n    }\n\n    dd {\n      text-align: left;\n      font-size: 13px;\n      line-height: 1.35;\n    }\n  }\n\n  &__order-panel-state {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    min-height: 220px;\n    color: #667085;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  &__order-panel-state--error,\n  &__order-panel-empty {\n    color: #b42318;\n  }\n\n  &__table--customers.dashboard-data-table {\n    width: 100%;\n    min-width: max-content;\n\n    th .definition-tooltip {\n      margin-left: 7px;\n    }\n\n    th .dashboard-data-table__sort {\n      letter-spacing: inherit;\n      line-height: inherit;\n      text-transform: uppercase;\n    }\n\n    th.sales-product-analytics-dashboard__tooltip-header {\n      position: relative;\n      overflow: visible;\n    }\n\n    th.sales-product-analytics-dashboard__tooltip-header:has(.definition-tooltip:hover),\n    th.sales-product-analytics-dashboard__tooltip-header:has(.definition-tooltip:focus-within) {\n      z-index: 20;\n    }\n\n    thead th {\n      padding: 18px 22px 14px;\n      background: #f8fafc;\n      color: #65758f;\n      font-size: 11px;\n      font-weight: 800;\n      letter-spacing: 0.06em;\n      line-height: 1.55;\n      text-transform: uppercase;\n      border-bottom-color: #edf2f7;\n      white-space: normal;\n    }\n\n    tbody td {\n      padding: 16px 22px;\n      color: #64748b;\n      font-size: 14px;\n      font-weight: 500;\n      border-top-color: #eef2f7;\n    }\n\n    tbody tr:hover td {\n      background: #fbfdff;\n    }\n\n    .dashboard-data-table__cell--emphasis {\n      color: #1e293b;\n      font-weight: 700;\n    }\n  }\n\n  &__table-card--top-products {\n    padding: 20px 0 0;\n    min-width: 0;\n  }\n\n  &__table-card--top-products .dashboard-data-table-panel__header {\n    min-height: 0;\n    padding: 14px 24px 12px;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  &__table-card--top-products .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__table-card--top-products .dashboard-data-table-scroll {\n    padding: 0 24px 20px;\n  }\n\n  &__table-card--orders {\n    padding: 22px 0 20px;\n  }\n\n  &__table-card--inventory {\n    padding: 22px 0 20px;\n    margin-top: 14px;\n  }\n\n  &__inventory-insights-header {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 18px;\n    margin: 8px 0;\n  }\n\n  &__inventory-insights-header .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 2px;\n  }\n\n  &__inventory-insights-header .sales-product-analytics-dashboard__card-subtitle {\n    margin: 0;\n  }\n\n  &__inventory-tools {\n    flex: 0 1 auto;\n    min-width: min(100%, 606px);\n    gap: 8px;\n    padding-bottom: 0;\n  }\n\n  &__inventory-tools .dashboard-data-table-panel__search {\n    flex: 0 0 300px;\n    width: 300px;\n    max-width: 300px;\n    min-width: 300px !important;\n    height: 40px;\n    padding: 0 12px;\n  }\n\n  &__inventory-tools .dashboard-data-table-panel__search input {\n    font-size: 13px;\n    padding-left: 8px;\n  }\n\n  &__inventory-tools .sales-product-analytics-dashboard__select-menu--inventory {\n    flex: 0 0 145px;\n    width: 145px;\n    min-width: 145px;\n    max-width: 145px;\n  }\n\n  &__inventory-tools .sales-product-analytics-dashboard__select-trigger {\n    height: 40px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n\n  &__select-menu--inventory-table {\n    flex: 0 0 145px;\n    width: 145px;\n    min-width: 145px;\n    max-width: 145px;\n  }\n\n  &__select-menu--inventory-table .sales-product-analytics-dashboard__select-trigger {\n    height: 40px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n\n  &__table-card--customers {\n    padding: 22px 0 20px;\n  }\n\n  &__table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 0 24px;\n    margin-bottom: 14px;\n  }\n\n  &__panel-tools {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n    gap: 8px;\n    min-width: 0;\n    flex: 1 1 auto;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 2px;\n  }\n\n  &__panel-tools .dashboard-data-table-panel__search {\n    min-width: 0 !important;\n    flex: 0 0 52%;\n    width: 52%;\n    max-width: 52%;\n  }\n\n  &__table-card--customers &__panel-tools,\n  &__table-card--orders &__panel-tools,\n  &__table-card--inventory &__panel-tools {\n    overflow: visible;\n  }\n\n  &__table-card--orders &__panel-tools {\n    margin-inline-start: auto;\n    flex: 0 1 auto;\n    justify-content: flex-end;\n  }\n\n  &__table-card--orders &__panel-tools .dashboard-data-table-panel__search {\n    flex: 0 0 auto;\n    width: auto;\n    min-width: 180px;\n    max-width: 290px;\n  }\n\n  &__table-card--customers &__panel-tools .dashboard-data-table-panel__search {\n    flex: 0 0 290px;\n    width: 290px;\n    max-width: 290px;\n    height: 42px;\n  }\n\n  &__export-menu {\n    position: relative;\n    flex: 0 0 auto;\n  }\n\n  &__export-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 9px;\n    height: 48px;\n    padding: 0 18px;\n    border: 1px solid #d7e1ee;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #475569;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;\n\n    &:hover:not(:disabled) {\n      border-color: #cbd5e1;\n      box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.55;\n    }\n\n    &--loading:disabled {\n      opacity: 1;\n    }\n  }\n\n  &__export-loader {\n    flex-shrink: 0;\n  }\n\n  &__table-card--customers &__export-button {\n    height: 42px;\n    min-width: 114px;\n    padding: 0 18px;\n  }\n\n  &__export-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    z-index: 30;\n    width: 124px;\n    padding: 6px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);\n\n    button {\n      display: block;\n      width: 100%;\n      padding: 10px 12px;\n      border: 0;\n      border-radius: 6px;\n      background: transparent;\n      color: #1e293b;\n      font-size: 13px;\n      font-weight: 700;\n      text-align: left;\n      cursor: pointer;\n\n      &:hover {\n        background: #f8fafc;\n      }\n    }\n  }\n\n  &__select-menu--toolbar {\n    flex: 0 0 auto;\n    min-width: min(128px, 22vw);\n    max-width: 200px;\n  }\n\n  &__panel-tools &__select-menu--toolbar.sales-product-analytics-dashboard__select-menu--orders,\n  &__panel-tools &__select-menu--toolbar.sales-product-analytics-dashboard__select-menu--inventory {\n    width: min(168px, 30vw);\n    min-width: min(120px, 22vw);\n    flex: 0 0 auto;\n  }\n\n  &__table-card--orders.dashboard-data-table-panel .dashboard-data-table-panel__header,\n  &__table-card--inventory.dashboard-data-table-panel .dashboard-data-table-panel__header,\n  &__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {\n    flex-wrap: nowrap;\n    //align-items: center;\n    min-height: 0;\n    padding-top: 28px;\n    padding-bottom: 28px;\n    gap: 10px;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 8px;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__card-subtitle {\n    margin: 0;\n  }\n\n  &__table-card--orders .dashboard-data-table-panel__header> :first-child,\n  &__table-card--inventory .dashboard-data-table-panel__header> :first-child,\n  &__table-card--customers .dashboard-data-table-panel__header> :first-child {\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n\n  &__table-card--inventory .dashboard-data-table-panel__header .sales-product-analytics-dashboard__title-with-tooltip,\n  &__table-card--customers .dashboard-data-table-panel__header .sales-product-analytics-dashboard__title-with-tooltip {\n    min-width: 0;\n    max-width: min(100%, 340px);\n  }\n\n  &__table-card--inventory .dashboard-data-table-panel__header .sales-product-analytics-dashboard__card-title,\n  &__table-card--customers .dashboard-data-table-panel__header .sales-product-analytics-dashboard__card-title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__orders-heading {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n    min-width: 0;\n  }\n\n  &__orders-heading .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__orders-count {\n    margin: 0;\n    color: #7a8aa0;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.35;\n  }\n\n  &__table-card--inventory .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__table thead th {\n    text-transform: uppercase;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__table thead th .dashboard-data-table__sort {\n    text-transform: uppercase;\n  }\n\n  &__table-card--inventory .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table--overview th,\n  &__table--overview td {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  &__table--top-products th,\n  &__table--top-products td {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  &__table--top-products th {\n    text-transform: uppercase;\n  }\n\n  &__table--top-products th:first-child,\n  &__table--top-products td:first-child {\n    padding-left: 0;\n  }\n\n  &__table--top-products th:last-child,\n  &__table--top-products td:last-child {\n    padding-right: 0;\n  }\n\n  &__table--top-products tbody tr:last-child td {\n    border-bottom: 0;\n  }\n\n  &__product-image-heading,\n  &__product-image-cell {\n    width: 44px;\n  }\n\n  &__product-image-frame {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: #f8fafc;\n    overflow: hidden;\n    color: #94a3b8;\n    position: relative;\n    vertical-align: middle;\n  }\n\n  &__product-image-frame--unavailable {\n    overflow: visible;\n    border: 0;\n    background: transparent;\n  }\n\n  &__product-image-frame img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__product-image-placeholder {\n    width: 15px;\n    height: 15px;\n  }\n\n  &__product-image-unavailable {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    outline: none;\n  }\n\n  &__product-image-question {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 999px;\n    background: #eef5ff;\n    color: #2b6cb0;\n    font-size: 22px;\n    font-weight: 500;\n    line-height: 1;\n  }\n\n  &__product-image-tooltip {\n    position: absolute;\n    top: calc(100% + 12px);\n    left: -10px;\n    z-index: 30;\n    display: none;\n    min-width: 208px;\n    padding: 11px 16px;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);\n    color: #6b7280;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.4;\n    white-space: nowrap;\n  }\n\n  &__product-image-tooltip::before {\n    content: \"\";\n    position: absolute;\n    top: -7px;\n    left: 24px;\n    width: 14px;\n    height: 14px;\n    border-top: 1px solid #e5e7eb;\n    border-left: 1px solid #e5e7eb;\n    background: #ffffff;\n    transform: rotate(45deg);\n  }\n\n  &__product-image-unavailable:hover &__product-image-tooltip,\n  &__product-image-unavailable:focus &__product-image-tooltip {\n    display: block;\n  }\n\n  &__product-name {\n    display: inline-block;\n    max-width: 220px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle;\n  }\n\n  &__pill,\n  &__status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__status {\n    min-height: 18px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 9px;\n    font-weight: 800;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  &__pill {\n    min-width: 48px;\n    padding: 7px 12px;\n    background: $sales-product-chart-primary;\n    color: #ffffff;\n  }\n\n  &__customer-segments {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n    max-width: 270px;\n  }\n\n  &__segment-chip {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 118px;\n    min-height: 24px;\n    padding: 6px 10px;\n    border-radius: 4px;\n    color: #ffffff;\n    font-size: 10px;\n    font-weight: 800;\n    line-height: 1;\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__segment-chip--loyal,\n  &__segment-chip--default {\n    background: #2563eb;\n  }\n\n  &__segment-chip--high-spenders {\n    background: #2dd4bf;\n  }\n\n  &__segment-chip--idle {\n    background: #a855f7;\n  }\n\n  &__segment-chip--unsubscribed {\n    background: #60a5fa;\n  }\n\n  &__segment-chip--one-timers {\n    background: #10b981;\n  }\n\n  &__segment-chip--cart-abandoners {\n    background: #ea580c;\n  }\n\n  &__segment-chip--indecisive {\n    background: #f59e0b;\n  }\n\n  &__segment-more {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 999px;\n    background: #2f74c7;\n    color: #ffffff;\n    font-size: 10px;\n    font-weight: 800;\n    line-height: 1;\n    cursor: default;\n    flex-shrink: 0;\n\n    &:hover .sales-product-analytics-dashboard__segment-tooltip,\n    &:focus-within .sales-product-analytics-dashboard__segment-tooltip {\n      opacity: 1;\n      visibility: visible;\n      transform: translate(-50%, 8px);\n    }\n  }\n\n  &__segment-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    z-index: 35;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: max-content;\n    padding: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.16);\n    opacity: 0;\n    visibility: hidden;\n    transform: translate(-50%, 2px);\n    transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: -6px;\n      left: 50%;\n      width: 10px;\n      height: 10px;\n      background: #ffffff;\n      border-left: 1px solid #e2e8f0;\n      border-top: 1px solid #e2e8f0;\n      transform: translateX(-50%) rotate(45deg);\n    }\n  }\n\n  &__status--completed,\n  &__status--fulfilled,\n  &__status--returning,\n  &__status--enabled,\n  &__status--in_stock {\n    background: #198754;\n    color: #fff;\n  }\n\n  &__status--pending,\n  &__status--unfulfilled,\n  &__status--partial,\n  &__status--new,\n  &__status--invited,\n  &__status--low_stock {\n    background: #f05a0a;\n    color: #fff;\n  }\n\n  &__status--refunded,\n  &__status--cancelled,\n  &__status--disabled,\n  &__status--out_of_stock {\n    background: #c33243;\n    color: #fff;\n  }\n\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 16px;\n    padding: 16px 20px 2px;\n  }\n\n  &__pagination-copy {\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n  }\n\n  &__pagination-controls {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__pagination-controls button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border: 1px solid #94a3b8;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #1f2937;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease;\n  }\n\n  &__pagination-controls button:hover:not(:disabled) {\n    background: $sales-product-muted-surface;\n  }\n\n  &__pagination-controls button:disabled {\n    opacity: 0.45;\n    color: #94a3b8;\n    cursor: not-allowed;\n  }\n\n  &__financial-bars {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  &__financial-bar-copy {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 6px;\n    color: #17325c;\n    font-size: 14px;\n  }\n\n  &__financial-bar-track {\n    height: 10px;\n    border-radius: 999px;\n    background: $sales-product-muted-surface;\n    overflow: hidden;\n  }\n\n  &__financial-bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: $sales-product-chart-primary;\n  }\n\n  @media (max-width: 1200px) {\n    &__metrics:not(.sales-product-analytics-dashboard__metrics--overview):not(.sales-product-analytics-dashboard__metrics--inventory):not(.sales-product-analytics-dashboard__metrics--three) {\n      grid-template-columns: 1fr;\n    }\n\n    &__metrics#{&}__metrics--three {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    &__metrics--inventory {\n      flex-direction: column !important;\n\n      >.dashboard-kpi-card {\n        //flex: 0 0 auto !important;\n        width: 100%;\n      }\n    }\n\n    &__metrics--overview {\n      grid-template-columns: 1fr !important;\n    }\n\n    &__grid,\n    &__grid--three {\n      grid-template-columns: 1fr;\n    }\n\n    &__overview-channel-body {\n      grid-template-columns: 1fr;\n      justify-items: stretch;\n    }\n\n    &__legend-list--overview-channel {\n      align-self: stretch;\n      max-width: none;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n\n    &__tabs {\n      padding: 6px;\n      gap: 6px;\n    }\n\n    &__tab {\n      width: 100%;\n      text-align: left;\n      padding: 12px 16px;\n    }\n\n    &__card,\n    &__metric-card,\n    &__table-card {\n      padding: 20px;\n      border-radius: 18px;\n    }\n\n    &__overview-title {\n      font-size: 24px;\n    }\n\n    &__overview-header {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__date-range {\n      width: 100%;\n      margin-left: 0;\n    }\n\n    &__date-range .organic-range-picker {\n      width: 100%;\n    }\n\n    &__date-range .organic-range-picker__control {\n      width: 100%;\n    }\n\n    &__metrics#{&}__metrics--three {\n      grid-template-columns: 1fr;\n    }\n\n    &__metrics--customers {\n      gap: 14px;\n    }\n\n    &__metrics--customers > .dashboard-kpi-card {\n      min-height: 118px;\n      padding: 20px;\n    }\n\n    &__metrics--customers .dashboard-kpi-card__value {\n      font-size: 28px;\n    }\n\n    &__metric-value {\n      font-size: 24px;\n    }\n\n    &__pagination {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    &__table-header {\n      flex-direction: column;\n      align-items: stretch;\n      padding: 0 20px;\n    }\n\n    &__filters--inline {\n      flex-wrap: wrap;\n      justify-content: stretch;\n    }\n\n    &__inventory-insights-header {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__inventory-tools {\n      width: 100%;\n      min-width: 0;\n      flex-wrap: wrap;\n      justify-content: stretch;\n    }\n\n    &__threshold-control {\n      width: 100%;\n      justify-content: space-between;\n    }\n\n    &__threshold-confirm {\n      right: 0;\n      width: min(402px, calc(100vw - 40px));\n    }\n\n    &__search--orders,\n    &__search--inventory,\n    &__search--customers,\n    &__select-menu--orders,\n    &__select-menu--inventory,\n    &__select-menu--inventory-table {\n      width: 100%;\n      min-width: 100%;\n      flex: 1 1 100%;\n    }\n\n    &__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {\n      flex-wrap: wrap;\n      align-items: stretch;\n    }\n\n    &__table-card--customers &__panel-tools {\n      width: 100%;\n      flex-wrap: wrap;\n      justify-content: stretch;\n    }\n\n    &__table-card--customers &__panel-tools .dashboard-data-table-panel__search,\n    &__export-menu,\n    &__export-button {\n      width: 100%;\n      max-width: none;\n      flex: 1 1 100%;\n    }\n  }\n\n  @media (max-width: 1100px) {\n    &__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {\n      flex-wrap: nowrap;\n      align-items: flex-start;\n      justify-content: space-between;\n    }\n\n    &__table-card--customers &__panel-tools {\n      margin-inline-start: auto;\n      flex: 0 1 auto;\n      flex-wrap: nowrap;\n      width: auto;\n      justify-content: flex-end;\n    }\n  }\n\n  @media (max-width: 768px) {\n    &__table-card--customers.dashboard-data-table-panel .dashboard-data-table-panel__header {\n      flex-wrap: nowrap;\n      align-items: flex-start;\n    }\n\n    &__table-card--customers &__panel-tools {\n      width: auto;\n      flex-wrap: nowrap;\n      justify-content: flex-end;\n    }\n\n    &__table-card--customers &__panel-tools .dashboard-data-table-panel__search {\n      width: auto;\n      min-width: 180px;\n      max-width: 290px;\n      flex: 0 1 auto;\n    }\n\n    &__table-card--customers &__export-menu,\n    &__table-card--customers &__export-button {\n      width: auto;\n      min-width: 0;\n      max-width: none;\n      flex: 0 0 auto;\n    }\n  }\n\n  @media (min-width: 800px) and (max-width: 1024px) {\n    .dashboard-section-header__actions {\n      justify-content: flex-end;\n    }\n  }\n\n  @media (min-width: 600px) and (max-width: 1100px) {\n    &__table-card--inventory.dashboard-data-table-panel .dashboard-data-table-panel__header {\n      flex-direction: row;\n      flex-wrap: nowrap;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    &__table-card--inventory .sales-product-analytics-dashboard__select-menu--inventory-table {\n      width: 145px;\n      min-width: 145px;\n      max-width: 145px;\n      flex: 0 0 auto;\n    }\n  }\n}\n\n/* Active tab panel scrolls; pill tabs stay fixed (dashboard route shell) */\n.sales-product-analytics-dashboard>*:not(.sales-product-analytics-dashboard__tabs) {\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  min-width: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.spa-trend-granularity {\n  display: inline-flex;\n  padding: 2px;\n  border-radius: 8px;\n  background: #edf3fb;\n  gap: 2px;\n  align-self: center;\n}\n\n.spa-trend-granularity__btn {\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  min-width: 52px;\n  height: 28px;\n  padding: 0 12px;\n  cursor: pointer;\n}\n\n.spa-trend-granularity__btn--active {\n  background: #ffffff;\n  color: #000000;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.spa-trend-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 4px 4px;\n}\n\n.spa-trend-pagination__label {\n  color: #7b8797;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.spa-trend-pagination__nav {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spa-trend-pagination__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #dce3ed;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n\n  &:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #334155;\n  }\n\n  &:disabled {\n    color: #cbd5e1;\n    cursor: not-allowed;\n    opacity: 0.8;\n  }\n}\n\n// Sales Attribution Filter Bar\n.sales-attribution__filter-bar-clear {\n  display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n    border-radius: 8px;\n    padding: 8px 14px;\n    min-height: 48px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #0f172a;\n    cursor: pointer;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.sales-attribution__filter-bar-clear-text {\n  padding-left: 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
